/* Alda commerce: cart store + drawer + PDP variant logic. Additive - core canvas JS untouched.
   Cart rows are built with DOM methods (textContent), never markup interpolation, since line
   data round-trips through localStorage. */
(function () {
  "use strict";
  var KEY = "alda_cart_v1";

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function store(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
  }
  function write(items) {
    store(items);
    renderPill(); renderLines();
    if (typeof mirrorSoon === "function") mirrorSoon();
  }
  function rupees(n) {
    return "₹" + Number(n).toLocaleString("en-IN");
  }
  /* The site's own addresses (/cook/cast-iron) and the host's (2026-11-04, the theme port): on Shopify a shelf is
     /collections/cast-iron, and the theme's layout sets window.aldaRoute to translate. Without it both are as they are. */
  function routeUrl(path) { return window.aldaRoute ? window.aldaRoute.url(path) : path; }
  function sitePath(path) { return window.aldaRoute ? window.aldaRoute.from(path) : path; }
  /* Prices (the sale, 2026-10-11). A variant's mrp is the catalogue MRP; its sale, when present and below the MRP,
     is what it sells for (alda-assets/content/sale.json, stamped onto alda-products.json by scratchpad/apply-sale.py).
     Mirrors scratchpad/site_parts.py price() / on_sale() / pct_off() / price_html() - keep the two in step. Exposed as
     window.aldaPrice for site-nav.js, pdp.js and the rest. */
  function priceOf(v) { var s = v && +v.sale; return s && s < v.mrp ? s : v.mrp; }
  function onSale(v) { return !!v && priceOf(v) < v.mrp; }
  function pctOff(v) { return onSale(v) ? Math.floor((v.mrp - priceOf(v)) * 100 / v.mrp) : 0; }
  /* A size still at the placeholder MRP (Rs 1 or less, until the client prices it) is not priced: wherever a price would
     show it says 'Price coming soon', with no figure, and it never goes into the cart (the owner, 2026-10-24; PDP review
     S2 - the static pages say the same, the rest follows window.aldaPrice.soon) */
  var SOON = "Price coming soon";
  // a size the client is not selling yet carries soon: true (2026-10-30: TruGlass and PEEK) - not for sale either, and
  // it says 'Coming soon' (site_parts.COMING / soon_text)
  var COMING = "Coming soon";
  function unpriced(v) { return !!v && (+v.mrp <= 1 || !!v.soon); }
  function soonText(v) { return v && v.soon ? COMING : SOON; }
  // the sizes a 'from' price may quote: the priced ones, when the family has any
  function priced(fam) {
    var vs = (fam && fam.variants) || [], ok = vs.filter(function (v) { return !unpriced(v); });
    return ok.length ? ok : vs;
  }
  /* <span class="pr is-sale">[lead]<span class="pr-now">₹399</span> <s class="pr-was"><span class="sf-vh">MRP </span>₹449</s></span>,
     or <span class="pr">[lead]₹449</span> - DOM nodes, never markup strings */
  function priceNode(v, lead) {
    var wrap = document.createElement("span");
    if (unpriced(v)) { wrap.className = "pr is-soon"; wrap.textContent = soonText(v); return wrap; }
    wrap.className = onSale(v) ? "pr is-sale" : "pr";
    if (lead) wrap.appendChild(document.createTextNode(lead));
    if (!onSale(v)) { wrap.appendChild(document.createTextNode(rupees(v.mrp))); return wrap; }
    var now = document.createElement("span"); now.className = "pr-now"; now.textContent = rupees(priceOf(v));
    var was = document.createElement("s"); was.className = "pr-was";
    var sr = document.createElement("span"); sr.className = "sf-vh"; sr.textContent = "MRP ";
    was.appendChild(sr); was.appendChild(document.createTextNode(rupees(v.mrp)));
    wrap.appendChild(now); wrap.appendChild(document.createTextNode(" ")); wrap.appendChild(was);
    return wrap;
  }
  // url: the Sale listing (sale.html at the root, 2026-10-12) - scratchpad/site_parts.py SALE_URL
  window.aldaPrice = { price: priceOf, onSale: onSale, pct: pctOff, rupees: rupees, node: priceNode, url: "/sale", soon: unpriced, soonText: SOON, soonFor: soonText };
  function count() { return read().reduce(function (s, i) { return s + i.qty; }, 0); }
  /* A cart line is { slug, name, label, mrp, price, img, qty[, shown] }: price is what the size sells for (the sale price
     when it has one), mrp its MRP. Lines saved before the sale carry no price - they count at their MRP until
     reprice() below brings them up to date. shown (2026-10-24, PDP review S3) is the size as the product page said it
     ('26 cm · 3.5 L'); the drawer shows it, and label stays the catalogue's ('26cm - 3.5L') for matching. */
  function unitPrice(i) { var p = +i.price; return p > 0 ? p : +i.mrp; }
  // the size a line (or a canvas tile) names, in a catalogue family
  function variantOf(fam, label) {
    var vs = (fam && fam.variants) || [];
    for (var k = 0; k < vs.length; k++) if (vs[k].label === label) return vs[k];
    return null;
  }
  // "from " only when the family's options sell at different prices (site_parts.from_lead, 2026-10-15)
  function fromLead(fam) {
    var seen = {};
    priced(fam).forEach(function (v) { seen[priceOf(v)] = 1; });
    return Object.keys(seen).length > 1 ? "from " : "";
  }
  // the size a family's "from" figure quotes: the lowest selling price, the first of equals (site_parts.from_variant)
  function fromVariant(fam) {
    var best = null;
    priced(fam).forEach(function (v) { if (!best || priceOf(v) < priceOf(best)) best = v; });
    return best;
  }
  // true when the variants are sizes of one thing (26cm, 3.0L, 370 ml, 8 x 11 in), not options of another kind (the knife
  // sets' grey and green since 2026-10-15), which are counted as options - site_parts.is_sizes / count_label, the cards' words
  function isSizes(fam) {
    return (fam.variants || []).every(function (v) {
      return v.size_cm || v.capacity_l || /^\s*[\d.]+\s*(cm|in\b|inch|l\b|ml\b)|^\s*\d+\s*x\s*\d+/i.test(v.label);
    });
  }
  /* Sizes that became another product. 2026-10-13: the steel-lid (Primero) tri-ply pieces got products of their own
     (scratchpad/split-primero.py), so three sizes saved under the glass-lid families now sell elsewhere - same piece,
     same price. "old slug|old label": [new slug, new label]. A line saved before the move is carried across by
     reprice() below, merged into a line already there for the same size. Add a row whenever a size changes product.
     2026-10-14 (scratchpad/tidy-tool-variants.py): three Prep Tools pieces were the ProChop pieces sold on their own
     pages, so they go there at those pages' prices; the two Essentials knife sets were split by colour within their own
     product - a line saved before the split never said which colour, so it becomes the grey, the set's default, as
     the catalogue shows it first. A move within one product (the same slug) is a rename: the product page opens on
     the new label in place (initPDP), and the cart line takes its price and photograph. 2026-10-15
     (scratchpad/split-sets.py): the Essentials sets and the Prep Tools became individual products, so every piece saved
     under them - colourless set lines included - moves straight to its own product; reprice() makes one hop only. */
  var MOVED = {
    "tri-ply-pressure-cooker|2.0L short": ["tri-ply-pressure-cooker-short", "2.0L short"],
    "tri-ply-pressure-cooker|3.5L short": ["tri-ply-pressure-cooker-short", "3.5L short"],
    "tri-ply-fry-pan|24cm + lid": ["tri-ply-fry-pan-glass-lid", "24cm + lid"],
    "tri-ply-fry-pan|26cm + lid": ["tri-ply-fry-pan-glass-lid", "26cm + lid"],
    "tri-ply-fry-pan|28cm + lid": ["tri-ply-fry-pan-glass-lid", "28cm + lid"],
    // Corrected from the client's promo dimension drawings, 2026-10-19.
    "endgrain-mango-cutting-board|9 x 11 in": ["endgrain-mango-cutting-board", "9 x 12 in"],
    "prochop-chef-knife|6 inch blade": ["prochop-chef-knife", "6.7 inch blade"],
    "tri-ply-casserole|26cm short - 3.0L": ["tri-ply-short-casserole", "26cm - 3.0L"],
    "tri-ply-casserole|30cm short - 5.0L": ["tri-ply-short-casserole", "30cm - 5.0L"],
    "tri-ply-kadai|36cm - 11L": ["tri-ply-kadai-steel-lid", "36cm - 11L"],
    "essentials-knife-sets|3 Knives Set": ["3-knives-set", "Grey"],
    "essentials-knife-sets|2 Knives + Peeler Set": ["2-knives-peeler-set", "Grey"],
    "essentials-knife-sets|3 Knives Set, Grey": ["3-knives-set", "Grey"],
    "essentials-knife-sets|3 Knives Set, Green": ["3-knives-set", "Green"],
    "essentials-knife-sets|2 Knives + Peeler Set, Grey": ["2-knives-peeler-set", "Grey"],
    "essentials-knife-sets|2 Knives + Peeler Set, Green": ["2-knives-peeler-set", "Green"],
    "essentials-knife-sets|5-Blade Herb Scissors": ["5-blade-herb-scissors", "One piece"],
    "essentials-knife-sets|Kitchen Scissors": ["kitchen-scissors", "One piece"],
    "essentials-knife-sets|3D Peeler": ["3d-peeler", "One piece"],
    "prep-tools|2D SS Peeler": ["2d-ss-peeler", "One piece"],
    "prep-tools|SS 4-Side Grater + container": ["ss-4-side-grater", "One piece"],
    "prep-tools|SS Grater": ["ss-grater", "One piece"],
    "prep-tools|Kitchen Scissors, spring action": ["prochop-scissors", "One piece"],
    "prep-tools|Knife Sharpener, 2-stage": ["prochop-knife-sharpener", "One piece"],
    "prep-tools|SS Y Peeler": ["prochop-peeler", "One piece"]
  };
  /* The photograph a line shows, by the rule a product page adds with (initPDP currentEntry): the size's own when it
     has one (the cookers' sizes differ in shape), else the product's. The product's is its white PDP main view, in the
     forms the site adds it with - the product page's first photograph or its 500px card copy (the family's "image",
     which is that main view since 2026-10-14) - and a line keeps whichever of those it has. Any other picture becomes
     the card copy: a canvas tile's cut-out (the canvas adds with the tile it shows), an older cut-out render, or one
     saved before a split that shows what is now the twin (a pre-split tri-ply-casserole line showing the steel-lid
     casserole, alda-primero-4). A product with no photograph at all leaves the line's as it is. */
  /* The family's variants are photographed on their own (variants[i].gallery: the cookers' sizes, the knife sets'
     colours - scratchpad/import-pdp-photos.py PER_SIZE; the product page holds a stack per variant) */
  function perVariant(fam) {
    return !!fam && (fam.variants || []).length > 1 && fam.variants.some(function (x) { return x.gallery && x.gallery.length; });
  }
  function lineImage(fam, v, img) {
    var own = v.gallery && v.gallery[0] && v.gallery[0].src;
    if (own) return own;
    // a family whose variants are photographed on their own: the product's photographs are another variant's, so a
    // variant without its own has none (the cart's logo stands in), as its product page shows the placeholder
    if (perVariant(fam)) return "";
    var card = fam.image ? "https://static.aldaindia.com/alda-assets/alda-" + fam.image + "-p-500.webp" : "";
    var page = fam.gallery && fam.gallery[0] ? fam.gallery[0].src : fam.image ? "https://static.aldaindia.com/alda-assets/alda-" + fam.image + ".webp" : "";
    if (img && (img === card || img === page)) return img;
    return card || page || img;
  }
  /* Lines are snapshots, so a sale that starts, changes or ends after a line went in would leave it at the old
     price. Against the loaded catalogue every line takes its size's current selling price and MRP, its product's
     current name (a renamed product - "Tri-Ply Kadai" became "Tri-Ply Kadai, Glass Lid" - reads as it sells) and a
     photograph of that product and size (lineImage); a moved size (MOVED) goes to its new product first; a line whose
     product or size has left the catalogue keeps what it had. Mutates items in place (a merged line is removed). True
     when anything changed. */
  function reprice(items) {
    if (!CATALOGUE) return false;
    var changed = false;
    for (var k = items.length - 1; k >= 0; k--) {
      var i = items[k], to = MOVED[i.slug + "|" + i.label], fam = to && CATALOGUE.fams[to[0]];
      if (!to || variantOf(CATALOGUE.fams[i.slug], i.label) || !variantOf(fam, to[1])) continue;
      var same = items.filter(function (o) { return o.slug === to[0] && o.label === to[1]; })[0];
      if (same) { same.qty += i.qty; items.splice(k, 1); }
      else { i.slug = to[0]; i.label = to[1]; delete i.shown; }   // its photograph follows below, as every line's does
      changed = true;
    }
    items.forEach(function (i) {
      var fam = CATALOGUE.fams[i.slug], v = variantOf(fam, i.label);
      if (!v) return;
      var p = priceOf(v), img = lineImage(fam, v, i.img);
      if (i.price !== p || i.mrp !== v.mrp) { i.price = p; i.mrp = v.mrp; changed = true; }
      if (fam.shortName && i.name !== fam.shortName) { i.name = fam.shortName; changed = true; }
      if (img !== i.img) { i.img = img; changed = true; }
    });
    return changed;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  }

  /* ---------- chrome injection (static skeleton only) ---------- */
  var pill, drawer, scrim, stub;
  function inject() {
    pill = el("button", "ac-cartpill");
    pill.setAttribute("aria-label", "Open cart");
    pill.appendChild(document.createTextNode("cart "));
    pill.appendChild(el("span", "ac-count", "0"));
    pill.addEventListener("click", open);
    document.body.appendChild(pill);
    applyGlass(pill, "pill");

    scrim = el("div", "ac-scrim");
    scrim.addEventListener("click", close);
    document.body.appendChild(scrim);

    drawer = el("aside", "ac-drawer");
    drawer.setAttribute("aria-label", "Cart");
    var head = el("div", "ac-dhead");
    head.appendChild(el("span", "t", "your cart"));
    var closeBtn = el("button", "ac-close", "×");
    closeBtn.setAttribute("aria-label", "Close cart");
    closeBtn.addEventListener("click", close);
    head.appendChild(closeBtn);
    drawer.appendChild(head);
    drawer.appendChild(el("div", "ac-lines"));
    var foot = el("div", "ac-dfoot");
    var tot = el("div", "ac-total");
    tot.appendChild(el("span", null, "total"));
    tot.appendChild(el("span", "ac-sum", "₹0"));
    foot.appendChild(tot);
    var co = el("button", "ac-checkout", "checkout");
    stub = el("p", "ac-stubnote",
      "Checkout connects at the platform stage (P4). Your cart is saved in this browser.");
    stub.setAttribute("role", "status");
    // on Shopify the button carries checkout's standard name, the one checkout apps look for
    if (NATIVE) co.name = "checkout";
    co.addEventListener("click", function () {
      if (!shopReady()) { stub.classList.add("show"); return; }
      checkout(co, stub);
    });
    foot.appendChild(co);
    foot.appendChild(stub);
    drawer.appendChild(foot);
    document.body.appendChild(drawer);

    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    renderPill(); renderLines();
    readShopifyCart();   // on Shopify: the store's cart is the cart
    window.addEventListener("pageshow", function (e) { if (e.persisted) readShopifyCart(); });
    // /#cart opens the cart: Shopify checkout's "Return to cart" lands here (the store's /cart page redirects to
    // the site's /#cart, scratchpad/shopify-theme/layout-theme.liquid; 2026-11-04, the launch). The hash is taken off
    // so a reload or a shared link doesn't open it again
    if (window.location.hash === "#cart") {
      open();
      try { history.replaceState(history.state, "", window.location.pathname + window.location.search); } catch (e) {}
    }
  }
  /* Checkout (2026-10-30): the cart goes to the Alda Shopify store's own checkout - payment, GST, shipping, order
     emails and the order itself are Shopify's, run by the client's team. The store's products mirror the catalogue
     (scratchpad/make-shopify-import-csv.py): handle = the slug, one variant per size whose first option is the
     catalogue label, so a line finds its variant by slug + label. A Storefront API cart is made from the lines and the
     shopper goes to its checkoutUrl. Until SHOP names the store (its myshopify domain and a public Storefront API
     token - public by design, read-only), the button keeps the note below. */
  // "Alda" (i407zk-hb), the client's own store under aldaindia.store@gmail.com (2026-10-30), its Headless channel's
  // public token ("Alda Headless" storefront)
  var SHOP = { domain: "i407zk-hb.myshopify.com", token: "8721ffa4dac018337da81b9433ff34b4", version: "2026-07" };
  function shopReady() { return !!(SHOP.domain && SHOP.token); }
  /* On Shopify itself (the theme sets window.aldaShopify, 2026-11-04 theme port) the cart is the store's own: every
     change is mirrored into Shopify's cart (/cart/*.js), checkout is Shopify's /checkout, and a page reads Shopify's
     cart back on load - so checkout apps see the cart, and what checkout kept is what the drawer shows. Elsewhere
     (www on Cloudflare) a Storefront cart is made at checkout, as before. */
  var NATIVE = !!window.aldaShopify, CART_TOKEN = "alda_cart_token";
  // the store's public Storefront API for the site's other scripts (season.js reads the client's Site banner from it)
  window.aldaShop = { ready: shopReady, query: function (q, vars) { return storefront(q, vars); } };
  function storefront(query, variables) {
    return fetch("https://" + SHOP.domain + "/api/" + SHOP.version + "/graphql.json", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": SHOP.token },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    }).then(function (j) {
      if (j.errors && j.errors.length) throw new Error(j.errors[0].message);
      return j.data;
    });
  }
  /* Stock (2026-11-03, the owner: "switch it on"). Shopify keeps the stock - the client's team enters it, every order
     takes from it - and the site asks the Storefront API which sizes can be sold (availableForSale) for the products on
     the page and in the cart. A size Shopify says no to is 'Out of stock': its size button says so, Add to cart / Buy now
     are switched off while it is chosen, every quick add refuses it, and a cart line of it is flagged. A product the
     store does not show (a draft, or not in the store at all) is out in every size; so is a size the store doesn't have.
     Until the answer is in, and if it never comes (offline), every size stays on sale: checkout() asks again before
     anything is paid. Answers are kept for a minute in this tab (sessionStorage), so the next page knows at once.
     Since 2026-11-04 one question covers the whole store, prices included (live prices, below): the menus' shelf lines
     quote every product, and it is one small answer a minute (~2.5 KB) instead of one per twenty products. */
  var OUT = "Out of stock";
  var STOCK_KEY = "alda_stock_v2", STOCK_TTL = 60 * 1000;
  // slug -> { t: when asked, gone: not in the store, v: { label: can be sold }, p: { label: [price, compare-at or 0] } }
  var stock = {};
  try { stock = JSON.parse(sessionStorage.getItem(STOCK_KEY)) || {}; } catch (e) { stock = {}; }
  var stockFns = [];
  function stockOut(slug, label) {
    var s = slug && stock[slug];
    if (!s) return false;
    return !!s.gone || s.v[label] !== true;
  }
  function stockKnown(slug) { return !!(slug && stock[slug]); }
  function onStock(fn) { stockFns.push(fn); if (Object.keys(stock).length) fn(); }
  function stockChanged() {
    applyLive();   // Shopify's prices first, so everything below draws with them
    stockFns.forEach(function (fn) { try { fn(); } catch (e) {} });
    renderLines();
  }
  // every product the store shows, with each size's availability and price - { handle: { v, p } }, in pages of 250
  function askStore() {
    var all = {};
    function page(after) {
      return storefront("query Store($after: String) { products(first: 250, after: $after) { pageInfo { hasNextPage endCursor }" +
        " nodes { handle variants(first: 50) { nodes { availableForSale selectedOptions { value } price { amount } compareAtPrice { amount } } } } } }",
        { after: after }).then(function (d) {
        d.products.nodes.forEach(function (prod) {
          var v = {}, p = {};
          prod.variants.nodes.forEach(function (n) {
            var opt = n.selectedOptions && n.selectedOptions[0];
            if (!opt) return;
            v[opt.value] = !!n.availableForSale;
            p[opt.value] = [+n.price.amount, n.compareAtPrice ? +n.compareAtPrice.amount : 0];
          });
          all[prod.handle] = { v: v, p: p };
        });
        return d.products.pageInfo.hasNextPage ? page(d.products.pageInfo.endCursor) : all;
      });
    }
    return page(null);
  }
  var stockAsk = null;   // the question in flight, shared by every caller
  function loadStock(slugs) {
    if (!shopReady()) return Promise.resolve();
    var now = Date.now();
    // one answer covers the whole store, so a page with no product of its own (About, the FAQ) asks too while this tab
    // has no fresh one: its menus quote prices, and every price is Shopify's (html.alda-priced, applyLive)
    var fresh = Object.keys(stock).some(function (s) { return now - stock[s].t < STOCK_TTL; });
    var stale = !fresh || slugs.some(function (s) { return s && !(stock[s] && now - stock[s].t < STOCK_TTL); });
    if (stale && !stockAsk) {
      stockAsk = askStore().then(function (all) {
        var t = Date.now();
        Object.keys(all).forEach(function (h) { stock[h] = { t: t, gone: false, v: all[h].v, p: all[h].p }; });
        return all;
      }, function () { return null; })   // offline or refused: what was known stays, the rest stays on sale
        .then(function (all) { stockAsk = null; return all; });
    }
    return (stale ? stockAsk : Promise.resolve(null)).then(function (all) {
      // a product the store does not show (a draft, or not in the store at all) is out in every size
      if (all) slugs.forEach(function (s) { if (s && !all[s]) stock[s] = { t: Date.now(), gone: true, v: {}, p: {} }; });
      try { sessionStorage.setItem(STOCK_KEY, JSON.stringify(stock)); } catch (e) {}
      stockChanged();
    });
  }
  // the products this page can add (its own, its pairings and quick adds, the experience view's tiles) and the cart's
  function pageSlugs() {
    var out = read().map(function (i) { return i.slug; });
    var fam = document.getElementById("ac-family");
    if (fam) { try { out.push(JSON.parse(fam.textContent).slug); } catch (e) {} }
    Array.prototype.forEach.call(document.querySelectorAll("[data-slug]"), function (n) { out.push(n.getAttribute("data-slug")); });
    return out;
  }
  /* The quick adds baked into pages: the PDP's Pairs with (a one-size '+', or the size buttons it opens) and the
     recipes' and home cards' '+'. A sold-out size is switched off and says so; a '+' whose every size is out too.
     (home.js draws its size choosers when they open, asking window.aldaStock itself.) */
  function markQuickAdds() {
    Array.prototype.forEach.call(document.querySelectorAll(".pl-pair-size"), function (o) {
      var box = o.closest("[id^='pp-']"), slug = box && box.id.slice(3), label = o.getAttribute("data-label");
      if (!stockKnown(slug) || +o.getAttribute("data-mrp") <= 1) return;
      var gone = stockOut(slug, label), p = o.querySelector(".p");
      if (p && !o.__price) o.__price = p.cloneNode(true);
      o.disabled = gone;
      o.classList.toggle("is-out", gone);
      if (p) p.replaceWith(gone ? el("span", "p is-out", OUT) : o.__price.cloneNode(true));
    });
    Array.prototype.forEach.call(document.querySelectorAll(".pl-pair-add, [data-add]"), function (b) {
      var slug = b.getAttribute("data-slug");
      if (!stockKnown(slug)) return;
      var labels = [];
      if (b.hasAttribute("data-label")) labels.push(b.getAttribute("data-label"));
      try { (JSON.parse(b.getAttribute("data-variants") || "[]") || []).forEach(function (v) { labels.push(v.label); }); } catch (e) {}
      var box = b.hasAttribute("aria-controls") && document.getElementById(b.getAttribute("aria-controls"));
      if (box) Array.prototype.forEach.call(box.querySelectorAll(".pl-pair-size"), function (o) { labels.push(o.getAttribute("data-label")); });
      if (!labels.length) return;
      var gone = labels.every(function (l) { return stockOut(slug, l); });
      if (gone && !b.disabled) { b.disabled = true; b.setAttribute("data-stock-off", ""); b.setAttribute("title", OUT); }
      else if (!gone && b.hasAttribute("data-stock-off")) { b.disabled = false; b.removeAttribute("data-stock-off"); b.removeAttribute("title"); }
      b.classList.toggle("is-out", gone);
    });
  }
  window.aldaStock = { out: stockOut, known: stockKnown, load: loadStock, on: onStock, text: OUT };

  /* Prices from Shopify (2026-11-04, the owner chose it: a price changed in Shopify shows on the site within a minute,
     so what a page says is what checkout charges). Where the store's price for a size differs from the one this deploy
     baked in, the size takes Shopify's: it sells at Shopify's price, and its MRP is the compare-at price when that is
     higher (a sale), else the price itself. A coming-soon size stays coming soon (the site says so, not the store); one
     still at the placeholder MRP that Shopify prices goes on sale. The catalogue's families are patched in place - the
     cart, the menus' thumbnails, the experience view and home.js's size chooser read them - and so is the product
     page's own (initPDP's live hook); the prices baked into this page's cards, Pairs with, recipe products and the
     menu's shelf lines are drawn again the way the build drew them. Where Shopify agrees nothing is touched. Search asks
     aldaPrice.live.
     Every price comes from Shopify, always (the owner, 2026-11-04): a figure the page was built with is never shown -
     commerce.css keeps them hidden until applyLive has drawn Shopify's and set html.alda-priced, and if Shopify never
     answers the price spots stay empty. A product page's JSON-LD offers are written from Shopify too (writeOffers). */
  function liveOf(slug, label) {
    var s = slug && stock[slug], p = s && s.p && s.p[label];
    if (!p || !(p[0] > 0)) return null;
    return p[1] > p[0] ? { mrp: p[1], sale: p[0] } : { mrp: p[0], sale: null };
  }
  // a variant as this deploy baked it in (kept on it the first time it is patched)
  function built(v) {
    if (!v.__built) v.__built = { mrp: v.mrp, sale: v.sale };
    return v.__built;
  }
  // a family takes Shopify's prices (a size with no answer goes back to its baked one); true when any size now sells at
  // a price, or carries an MRP, other than the baked one
  function patchLive(fam) {
    if (!fam || !fam.variants) return false;
    var moved = false;
    fam.variants.forEach(function (v) {
      var b = built(v), to = (!v.soon && liveOf(fam.slug, v.label)) || b;
      v.mrp = to.mrp;
      if (to.sale) v.sale = to.sale; else delete v.sale;
      if (v.mrp !== b.mrp || priceOf(v) !== priceOf(b)) moved = true;
    });
    return moved;
  }
  function famUnpriced(fam) { return fam.variants.every(unpriced); }
  // pdp_layout.price_cell: a size's price, then its 'N% off' (none under 1%)
  function sizeCell(v) {
    var f = document.createDocumentFragment(), off = pctOff(v);
    f.appendChild(priceNode(v));
    f.appendChild(document.createTextNode(" "));
    if (off > 0) f.appendChild(el("span", "pr-off", off + "% off"));
    return f;
  }
  // site_parts.price_html(from_variant(f), from_lead(f)): a family's 'from' line
  function famCell(fam) { return priceNode(fromVariant(fam), fromLead(fam)); }
  // site_parts.family_pct / family_off_html: the deepest cut, and 'N% off' or 'Up to N% off'
  function famPct(fam) { return fam.variants.reduce(function (n, v) { return Math.max(n, pctOff(v)); }, 0); }
  function famOff(fam) {
    var pcts = [];
    fam.variants.forEach(function (v) { if (onSale(v) && pcts.indexOf(pctOff(v)) < 0) pcts.push(pctOff(v)); });
    var n = famPct(fam);
    if (!pcts.length || n <= 0) return null;
    return el("span", "pr-off", (pcts.length === 1 && fam.variants.every(onSale) ? "" : "Up to ") + n + "% off");
  }
  function band(p) { return p < 1500 ? "p1" : p < 3000 ? "p2" : p < 5000 ? "p3" : "p4"; }   // build_plp.price_band
  // a price box is drawn again only where it holds a price now (a figure, or a .pr), never where it holds other words
  function paint(box, node) {
    if (!box || !(box.querySelector(".pr") || /₹/.test(box.textContent))) return;
    box.replaceChildren(node);
  }
  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }
  // the product this page is about (its #ac-family), or null - read once
  var ownSlug;
  function pageSlug() {
    if (ownSlug === undefined) {
      var n = document.getElementById("ac-family");
      try { ownSlug = n ? JSON.parse(n.textContent).slug : null; } catch (e) { ownSlug = null; }
    }
    return ownSlug;
  }
  /* A product page's structured data (JSON-LD, what search engines read): its offers are what Shopify sells the sizes
     for, written here once Shopify has answered - the page is built without them (2026-11-04). Only sizes Shopify
     prices are offered; a coming-soon size, or one still at the Rs 1 placeholder, never is (build_shop's old rule). */
  function writeOffers(fam) {
    Array.prototype.forEach.call(document.querySelectorAll('script[type="application/ld+json"]'), function (node) {
      var data;
      try { data = JSON.parse(node.textContent); } catch (e) { return; }
      if (!data || data["@type"] !== "Product") return;
      var prices = [];
      fam.variants.forEach(function (v) {
        var lp = !v.soon && liveOf(fam.slug, v.label), p = lp && (lp.sale || lp.mrp);
        if (p > 1) prices.push(p);
      });
      if (prices.length) data.offers = { "@type": "AggregateOffer", priceCurrency: "INR", lowPrice: Math.min.apply(null, prices),
        highPrice: Math.max.apply(null, prices), offerCount: prices.length };
      else delete data.offers;
      var text = JSON.stringify(data);
      if (node.textContent !== text) node.textContent = text;
    });
  }
  function setNum(n, attr, val) { if (n.hasAttribute(attr)) n.setAttribute(attr, String(val)); }
  // the prices baked into this page for one family, drawn again from its patched sizes
  function paintFamily(fam) {
    var slug = fam.slug;
    // the elements matching sel that link to this product (with or without a ?size=)
    function at(sel) { return sel + '[href="/products/' + slug + '"], ' + sel + '[href^="/products/' + slug + '?"]'; }
    // listing cards (build_plp): the 'from' line, the sort and filter keys, the discount tag in the art's corner
    each('article.pc[data-slug="' + slug + '"]', function (card) {
      var lo = fromVariant(fam), pct = famPct(fam), off = famOff(fam), tag = card.querySelector(".pc-off");
      paint(card.querySelector(".pc-price"), famCell(fam));
      card.setAttribute("data-price", String(priceOf(lo)));
      card.setAttribute("data-pricebucket", famUnpriced(fam) ? "" : band(priceOf(lo)));
      if (pct > 0) card.setAttribute("data-off", String(pct)); else card.removeAttribute("data-off");
      if (off && tag) tag.replaceChildren(off);
      else if (off) { var art = card.querySelector(".pc-art"), t = el("span", "pc-off"); t.appendChild(off); if (art) art.insertBefore(t, art.querySelector(".pc-badges")); }
      else if (tag) tag.remove();
      // build_plp.card_href: the card opens on the size its 'from' price quotes while that size is on sale and the
      // product has others, else on the product
      var lv = fam.variants.length > 1 && onSale(lo) ? lo : null;
      Array.prototype.forEach.call(card.querySelectorAll('a[href="/products/' + slug + '"], a[href^="/products/' + slug + '?"]'), function (a) {
        a.setAttribute("href", "/products/" + slug + (lv ? "?size=" + encodeURIComponent(lv.label) : ""));
      });
    });
    // related cards (.ac-card), quick cards (recipes, kitchen-depth, 404) and the menus' product rows: the 'from' line
    each(at("a.ac-card"), function (a) {
      setNum(a, "data-price", priceOf(fromVariant(fam)));
      paint(a.querySelector(".p"), famCell(fam));
    });
    each(at(".hm-pcard > a.hit"), function (a) { paint(a.querySelector(".t"), famCell(fam)); });
    // Pairs with (pdp_layout): a row quotes one size (its add button names it) or, with sizes, the lowest of those it
    // offers; each size button its own price
    each(".pl-pairs li", function (li) {
      var a = li.querySelector(at("a"));
      if (!a) return;
      var box = document.getElementById("pp-" + slug), one = li.querySelector(".pl-pair-add[data-label]");
      if (box && li.contains(box)) {
        var offered = [];
        Array.prototype.forEach.call(box.querySelectorAll(".pl-pair-size"), function (o) {
          var v = variantOf(fam, o.getAttribute("data-label"));
          if (!v) return;
          offered.push(v);
          setNum(o, "data-mrp", v.mrp); setNum(o, "data-price", priceOf(v));
          paint(o.querySelector(".p"), priceNode(v));
        });
        if (offered.length) paint(a.querySelector(".p"), famCell({ variants: offered }));
      } else {
        var v = one ? variantOf(fam, one.getAttribute("data-label")) : fam.variants.length === 1 ? fam.variants[0] : null;
        if (v) paint(a.querySelector(".p"), priceNode(v));
      }
    });
    // the compare table on a knife's product page (pdp_more): a column's price, by the product its link opens - the
    // page's own column (is-this) links nowhere
    each(".pm-table th .pm-price", function (box) {
      var th = box.closest("th"), link = th.querySelector(".pm-link");
      var named = link ? (link.getAttribute("href") || "").split("?")[0] === "/products/" + slug
        : th.classList.contains("is-this") && pageSlug() === slug;
      if (named) paint(box, famCell(fam));
    });
    // recipe products (rc-prod): the size the recipe uses, named by its add button
    each(".rc-prod", function (row) {
      var add = row.querySelector('[data-add][data-slug="' + slug + '"]'), v = add && variantOf(fam, add.getAttribute("data-label"));
      if (v) paint(row.querySelector(".rc-prod-p"), (function () {
        var f = document.createDocumentFragment();
        f.appendChild(document.createTextNode(v.label + " · ")); f.appendChild(priceNode(v)); return f;
      })());
    });
    // every quick add's own figures (what it puts in the cart until reprice() has the catalogue)
    each('[data-add][data-slug="' + slug + '"], .pl-pair-add[data-slug="' + slug + '"]', function (b) {
      var v = b.hasAttribute("data-label") && variantOf(fam, b.getAttribute("data-label"));
      if (v) { setNum(b, "data-mrp", v.mrp); setNum(b, "data-price", priceOf(v)); }
    });
  }
  /* the shop menu's shelf lines ('28 products · from ₹199': the lowest selling price on the shelf, its "also" families
     too - patch-landing-catalogue.shelf_text): drawn again where a patched price moves that lowest figure */
  function placedOn(f, name) { return f.sub === name || (f.also || []).some(function (p) { return p.sub === name; }); }
  function paintShelves() {
    if (!CATALOGUE) return;
    var bySlug = {};
    Object.keys(CATALOGUE.subs).forEach(function (n) { bySlug[CATALOGUE.subs[n].slug] = n; });
    each("a.mn-sub[href] .t", function (t) {
      var name = bySlug[(t.parentNode.getAttribute("href") || "").split("/").pop()];
      if (!name || !/from ₹/.test(t.textContent)) return;
      var low = null, was = null;   // the lowest selling price on the shelf now, and as baked
      CATALOGUE.data.families.forEach(function (f) {
        if (!placedOn(f, name)) return;
        f.variants.forEach(function (v) {
          var b = built(v);
          if (!unpriced(v)) low = low === null ? priceOf(v) : Math.min(low, priceOf(v));
          if (!unpriced({ mrp: b.mrp, soon: v.soon })) was = was === null ? priceOf(b) : Math.min(was, priceOf(b));
        });
      });
      if (low === null) return;
      if (low !== was || t.__live) t.textContent = t.textContent.replace(/from ₹[\d,]+/, "from " + rupees(low));
      t.__live = low !== was;
    });
  }
  var liveShown = {}, pdpLive = null, catalogueAsked = false;
  // drawn with Shopify's prices: the families this page shows as patched (and those it drew so and must draw back)
  function applyLive() {
    if (!Object.keys(stock).length) return;
    if (pdpLive) pdpLive();
    if (!CATALOGUE) {
      // the cards and shelf lines are drawn from the catalogue; fetched once, then this runs again
      if (!catalogueAsked) { catalogueAsked = true; loadCatalogue().then(function (c) { if (c) applyLive(); }); }
      return;
    }
    var any = false;
    Object.keys(CATALOGUE.fams).forEach(function (slug) {
      var fam = CATALOGUE.fams[slug], moved = patchLive(fam);
      if (moved || liveShown[slug]) { paintFamily(fam); any = true; }
      liveShown[slug] = moved;
    });
    if (any) paintShelves();
    // what is on sale is Shopify's now: the Sale listing (minimal.js) and the homepage's sale edit (home-editorial.js)
    // choose their products again (2026-11-04); liveAt for a script that starts listening after this
    window.aldaPrice.liveAt = Date.now();
    // every price on the page is Shopify's now: commerce.css shows them
    document.documentElement.classList.add("alda-priced");
    document.dispatchEvent(new CustomEvent("alda:prices"));
  }
  // the catalogue family for a product whose prices Shopify has changed (search draws its line from it), else null
  function liveFamily(slug) { return CATALOGUE && liveShown[slug] ? CATALOGUE.fams[slug] : null; }
  window.aldaPrice.live = liveFamily;
  // any catalogue family, with Shopify's prices once they are in (null until the catalogue has loaded), and the
  // catalogue itself (a promise, fetched once per page) - for the scripts that choose what the sale shows
  window.aldaPrice.family = function (slug) { return CATALOGUE && CATALOGUE.fams[slug] || null; };
  window.aldaPrice.catalogue = function () { return loadCatalogue(); };
  window.aldaPrice.famPct = famPct;
  window.aldaPrice.from = fromVariant;
  window.aldaPrice.lead = fromLead;
  var checkingOut = false;
  function checkout(btn, note) {
    var items = read().filter(function (i) { return !unpriced(i) && i.qty > 0; });
    if (!items.length || checkingOut) return;
    checkingOut = true;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = "opening checkout…";
    note.classList.remove("show");
    function fail(msg) {
      checkingOut = false;
      btn.disabled = false;
      btn.textContent = label;
      note.textContent = msg;
      note.classList.add("show");
    }
    variantLines(items).then(function (res) {
      var lines = res.lines, gone = res.gone;
      if (gone.length) {
        fail("Not available to order right now: " + gone.join(", ") + ". Remove it to continue.");
        return;
      }
      // back from Shopify's checkout, the browser may restore this page as it was left: the button comes back
      function comeBack() {
        window.addEventListener("pageshow", function again(e) {
          if (!e.persisted) return;
          window.removeEventListener("pageshow", again);
          checkingOut = false; btn.disabled = false; btn.textContent = label;
          if (NATIVE) readShopifyCart();
        });
      }
      if (NATIVE) {
        // the store's own cart, then the store's own checkout (checkout apps take over from here); a mirror still
        // waiting is cancelled, one under way finished first, so the two never interleave their clear and add
        clearTimeout(mirrorTimer);
        return mirroring.then(function () { return putShopifyCart(lines); }).then(function () {
          try { localStorage.removeItem(CART_DIRTY); } catch (e) {}
          comeBack(); window.location.href = "/checkout";
        });
      }
      return storefront("mutation Cart($lines: [CartLineInput!]!) { cartCreate(input: { lines: $lines }) { cart { checkoutUrl } userErrors { message } } }",
        { lines: lines }).then(function (d) {
        var res = d && d.cartCreate;
        if (!res || !res.cart || !res.cart.checkoutUrl) {
          fail((res && res.userErrors && res.userErrors[0] && res.userErrors[0].message) || "Checkout could not open. Please try again.");
          return;
        }
        comeBack();
        window.location.href = res.cart.checkoutUrl;
      });
    }).catch(function () {
      fail("Checkout could not open. Please check your connection and try again.");
    });
  }

  // each cart line's Shopify variant (by slug + its first option, the catalogue label): { lines, gone } - lines as
  // Storefront cart lines, gone the names of those the store can't sell now
  function variantLines(items) {
    var slugs = [];
    items.forEach(function (i) { if (slugs.indexOf(i.slug) < 0) slugs.push(i.slug); });
    if (!slugs.length) return Promise.resolve({ lines: [], gone: [] });
    var q = "query Lines {" + slugs.map(function (s, k) {
      return " p" + k + ": product(handle: " + JSON.stringify(s) + ") { variants(first: 100) { nodes { id availableForSale selectedOptions { value } } } }";
    }).join("") + " }";
    return storefront(q).then(function (data) {
      var lines = [], gone = [];
      items.forEach(function (i) {
        var prod = data["p" + slugs.indexOf(i.slug)];
        var nodes = (prod && prod.variants && prod.variants.nodes) || [];
        var hit = null;
        for (var k = 0; k < nodes.length; k++) {
          var opt = nodes[k].selectedOptions && nodes[k].selectedOptions[0];
          if (opt && opt.value === i.label) { hit = nodes[k]; break; }
        }
        if (!hit || !hit.availableForSale) gone.push(i.name + (i.shown || i.label ? " (" + (i.shown || i.label) + ")" : ""));
        else lines.push({ merchandiseId: hit.id, quantity: i.qty });
      });
      return { lines: lines, gone: gone };
    });
  }
  /* ---------- the store's own cart (NATIVE: on Shopify) ---------- */
  // Shopify's AJAX cart: /cart.js reads it, /cart/<clear|add|change>.js changes it
  function cartApi(path, body) {
    return fetch(path === "cart.js" ? "/cart.js" : "/cart/" + path, body ?{ method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }
      : { headers: { Accept: "application/json" } }).then(function (r) { if (!r.ok) throw new Error("cart " + r.status); return r.json(); });
  }
  // Shopify's cart becomes exactly these lines (clear, then one add); its token is kept to know it again
  function putShopifyCart(lines) {
    return cartApi("clear.js", {}).then(function () {
      if (!lines.length) return null;
      return cartApi("add.js", { items: lines.map(function (l) { return { id: +String(l.merchandiseId).split("/").pop(), quantity: l.quantity }; }) });
    }).then(function () { return cartApi("cart.js"); }).then(function (c) {
      try { localStorage.setItem(CART_TOKEN, c.token); } catch (e) {}
      return c;
    });
  }
  // every change to the cart reaches Shopify's soon after (a burst of changes is one update). Until it has, the
  // browser keeps a mark (CART_DIRTY, the change's time): a page left within the wait sends the cart up on the next
  // page instead of reading Shopify's older one down. A size the store can't sell stays out of Shopify's cart - flagged
  // in the drawer until the next page reads Shopify's cart back, as checkout would take it out.
  var CART_DIRTY = "alda_cart_dirty", mirrorTimer = null, mirroring = Promise.resolve();
  function mirrorSoon() {
    if (!NATIVE) return;
    var mark = String(Date.now());
    try { localStorage.setItem(CART_DIRTY, mark); } catch (e) {}
    clearTimeout(mirrorTimer);
    mirrorTimer = setTimeout(function () {
      var items = read().filter(function (i) { return !unpriced(i) && i.qty > 0; });
      mirroring = variantLines(items).then(function (res) { return putShopifyCart(res.lines); }).then(function () {
        try { if (localStorage.getItem(CART_DIRTY) === mark) localStorage.removeItem(CART_DIRTY); } catch (e) {}
      }).catch(function () {});
    }, 400);
  }
  /* On load (and back from checkout): Shopify's cart is the cart. Its lines replace the drawer's - so a size checkout
     took out is gone here too - keeping each line's name and photo from the drawer, or Shopify's for one added
     elsewhere. An empty Shopify cart after one this browser filled means the order was placed (or the cart lapsed):
     the drawer empties. A first visit with a cart from before (www on Cloudflare) sends it up instead. */
  function readShopifyCart() {
    if (!NATIVE) return;
    var dirty = null;
    try { dirty = localStorage.getItem(CART_DIRTY); } catch (e) {}
    if (dirty) { mirrorSoon(); return; }   // a change Shopify hasn't had yet: send it, don't read the older cart
    cartApi("cart.js").then(function (c) {
      var local = read(), known = null;
      try { known = localStorage.getItem(CART_TOKEN); } catch (e) {}
      if (!c.items.length) {
        if (known && local.length) { write([]); try { localStorage.removeItem(CART_TOKEN); } catch (e) {} }
        else if (!known && local.length) mirrorSoon();
        return;
      }
      var next = c.items.map(function (it) {
        var label = it.options_with_values && it.options_with_values[0] ? it.options_with_values[0].value : (it.variant_title || "");
        var had = local.find(function (i) { return i.slug === it.handle && i.label === label; });
        var line = had ? JSON.parse(JSON.stringify(had)) : { slug: it.handle, name: it.product_title, label: label, img: it.image, mrp: it.original_price / 100 };
        line.qty = it.quantity; line.price = it.final_price / 100;
        if (!line.mrp || line.mrp < line.price) line.mrp = line.price;
        return line;
      });
      try { localStorage.setItem(CART_TOKEN, c.token); } catch (e) {}
      if (JSON.stringify(next) !== JSON.stringify(local)) { store(next); renderPill(); renderLines(); }
    }).catch(function () {});
  }

  function open() { document.body.classList.add("ac-open"); }
  function close() { document.body.classList.remove("ac-open"); }

  function renderPill() {
    if (!pill) return;
    var n = count();
    pill.querySelector(".ac-count").textContent = n;
    pill.classList.toggle("is-empty", n === 0);
    refreshAllGlass();  // the count changes the pill's width, and so its refraction map
  }

  var repriceQueued = false;
  function renderLines() {
    if (!drawer) return;
    var box = drawer.querySelector(".ac-lines");
    box.textContent = "";
    var items = read();
    if (items.length) {
      // today's prices: at once when this page has the catalogue, otherwise once it has fetched it (most pages
      // load it only for this) - the drawer then renders again, and the corrected lines are saved
      if (CATALOGUE) { if (reprice(items)) store(items); }
      else if (!repriceQueued) {
        repriceQueued = true;
        loadCatalogue().then(function (c) { if (c) renderLines(); });
      }
    }
    if (!items.length) {
      box.appendChild(el("div", "ac-empty",
        "Nothing here yet — drag the canvas, find a pan."));
    }
    items.forEach(function (i, idx) {
      var row = el("div", "ac-lineitem");
      var img = el("img");
      img.src = i.img || "https://static.aldaindia.com/alda-assets/alda-logo.svg"; img.alt = i.img ? "" : "Alda"; img.loading = "lazy";
      if (!i.img) img.className = "is-logo";   // the wordmark stands in, whole; a photograph fills its tile (commerce.css)
      // catalogue art is uniformly square; stating it stops the drawer reflowing as thumbs land
      img.width = 500; img.height = 500;
      row.appendChild(img);

      var mid = el("div");
      mid.appendChild(el("div", "n", i.name));
      mid.appendChild(el("div", "v", i.shown || i.label));
      // sold out since it went in (window.aldaStock): it says so, and no more of it can be added
      var gone = !unpriced(i) && stockOut(i.slug, i.label);
      if (gone) { row.classList.add("is-out"); mid.appendChild(el("div", "ac-out", OUT + ". Remove it to check out.")); }
      var qty = el("div", "ac-qty");
      var minus = el("button", null, "−");
      minus.setAttribute("aria-label", "Less");
      var q = el("span", "q", String(i.qty));
      var plus = el("button", null, "+");
      plus.setAttribute("aria-label", "More");
      if (unpriced(i) || gone) plus.disabled = true;   // a line saved before its size lost its placeholder price: no more of it
      minus.addEventListener("click", function () { bump(idx, -1); });
      plus.addEventListener("click", function () { bump(idx, 1); });
      qty.appendChild(minus); qty.appendChild(q); qty.appendChild(plus);
      mid.appendChild(qty);
      var rm = el("button", "ac-remove", "remove");
      rm.addEventListener("click", function () {
        var arr = read(); arr.splice(idx, 1); write(arr);
      });
      mid.appendChild(rm);
      row.appendChild(mid);

      // the line at its selling price; on sale, the MRP for the same quantity struck beside it
      var lp = el("div", "lp");
      lp.appendChild(unpriced(i) ? priceNode(i) : priceNode({ mrp: i.mrp * i.qty, sale: unitPrice(i) * i.qty }));
      row.appendChild(lp);
      box.appendChild(row);
    });
    // a line that is not priced yet counts for nothing; nor does a sold-out one, which keeps checkout shut until it is
    // removed (2026-11-04, the user-flow test: the button stayed live and the line counted; checkout() refused it only
    // once it had asked Shopify)
    var held = items.filter(function (i) { return !unpriced(i) && stockOut(i.slug, i.label); }).length;
    drawer.querySelector(".ac-sum").textContent = rupees(items.reduce(function (s, i) {
      return s + (unpriced(i) || stockOut(i.slug, i.label) ? 0 : i.qty * unitPrice(i));
    }, 0));
    var co = drawer.querySelector(".ac-checkout");
    if (co && !checkingOut) co.disabled = held > 0;
    if (stub && held) { stub.textContent = "Remove the out-of-stock item" + (held > 1 ? "s" : "") + " to check out."; stub.classList.add("show"); stub.__held = true; }
    else if (stub && stub.__held) { stub.classList.remove("show"); stub.__held = false; }
  }

  function bump(idx, d) {
    var arr = read();
    if (!arr[idx] || (d > 0 && (unpriced(arr[idx]) || stockOut(arr[idx].slug, arr[idx].label)))) return;
    arr[idx].qty += d;
    if (arr[idx].qty <= 0) arr.splice(idx, 1);
    write(arr);
  }

  // { quiet: true } leaves the drawer shut: cart-fly.js confirms with its own add-to-cart stream
  // entry: { slug, name, label, mrp, price, img[, shown] } - price the selling price (window.aldaPrice.price(v)), mrp the
  // MRP, shown the size as the product page says it. An entry without a price goes in at its MRP and reprice() corrects
  // it once the catalogue is in. One whose MRP is the placeholder (Rs 1 or less) is refused: false, and nothing changes.
  function addToCart(entry, opts) {
    // Shopify's price for the size, where the store has one (live prices): what checkout will charge
    var lp = entry && !entry.soon && liveOf(entry.slug, entry.label);
    if (lp) {
      var copy = {};
      for (var k in entry) copy[k] = entry[k];
      copy.mrp = lp.mrp; copy.price = lp.sale || lp.mrp;
      entry = copy;
    }
    if (!entry || unpriced(entry)) return false;
    // sold out (window.aldaStock): nothing goes in; the drawer opens on the cart as it is and says why
    if (stockOut(entry.slug, entry.label)) {
      if (stub) {
        stub.textContent = OUT + ": " + entry.name + (entry.shown || entry.label ? " (" + (entry.shown || entry.label) + ")" : "") + ".";
        stub.classList.add("show");
      }
      open();
      return false;
    }
    var items = read();
    var mrp = +entry.mrp, price = +entry.price > 0 ? +entry.price : mrp;
    var match = items.find(function (i) { return i.slug === entry.slug && i.label === entry.label; });
    if (match) {
      match.qty += 1;
      // an add that names its price knows today's price
      if (+entry.price > 0) { match.price = price; match.mrp = mrp; }
      if (entry.shown) match.shown = entry.shown;
    } else {
      var line = { slug: entry.slug, name: entry.name, label: entry.label, mrp: mrp, price: price, img: entry.img, qty: 1 };
      if (entry.shown) line.shown = entry.shown;
      items.push(line);
    }
    write(items);
    if (!(opts && opts.quiet)) open();
    return true;
  }

  /* ---------- PDP wiring ---------- */
  /* A product page's address can name the size it opens on: /products/<slug>?size=<variant label>, URL-encoded
     (encodeURIComponent; a '+' in the query reads as a space, so '24cm + lid' travels as 24cm%20%2B%20lid). The
     experience view's 'view product' and any link quoting one size (the Sale card's 'from' size) use it. The label
     must match a variant exactly, else the page opens on the hero as it always did. Once the visitor picks a size,
     the address names it - replaced in place, never a new history entry - so a reload or a shared link keeps it. */
  function sizeQuery(search, label) {
    // the query with ?size= set to label (null: removed); every other parameter is kept as written
    var keep = (search || "").replace(/^\?/, "").split("&").filter(function (p) {
      return p && p.split("=")[0] !== "size";
    });
    if (label !== null) keep.push("size=" + encodeURIComponent(label));
    return keep.length ? "?" + keep.join("&") : "";
  }
  function writeSize(label) {
    var q = sizeQuery(window.location.search, label);
    if (q === window.location.search || !(window.history && history.replaceState)) return;
    try { history.replaceState(history.state, "", window.location.pathname + q + window.location.hash); } catch (e) {}
  }
  function initPDP() {
    var data = document.getElementById("ac-family");
    if (!data) return;
    var fam = JSON.parse(data.textContent);
    var asked = null, linked = -1;
    try { asked = new URLSearchParams(window.location.search).get("size"); } catch (e) {}
    if (asked !== null) fam.variants.forEach(function (v, k) { if (linked < 0 && v.label === asked) linked = k; });
    // an older link naming a size that has since become another product (MOVED) goes on to it, at that size; one
    // renamed within this product (a set split by colour) opens on its new label here, and the address names it
    var moved = asked !== null && linked < 0 && MOVED[fam.slug + "|" + asked];
    if (moved && moved[0] === fam.slug) {
      fam.variants.forEach(function (v, k) { if (linked < 0 && v.label === moved[1]) linked = k; });
      if (linked >= 0) { asked = moved[1]; writeSize(asked); }
    } else if (moved) {
      window.location.replace("/products/" + moved[0] + sizeQuery(window.location.search, moved[1]) + window.location.hash);
      return;
    }
    var sel = linked >= 0 ? linked : fam.hero;
    var price = document.querySelector(".ac-price");
    var pills = Array.prototype.slice.call(document.querySelectorAll(".ac-pill"));
    var bar = document.querySelector(".ac-buybar");
    var bbVar = bar && bar.querySelector(".ac-bb-var");
    var bbPrice = bar && bar.querySelector(".ac-bb-price");
    // the size row is one named group whose chosen button says so to a screen reader (aria-pressed, as the rings do);
    // its name is the row's own label ('Size', or the word a set's options go by) - 2026-10-24, PDP review S15
    var list = document.querySelector(".pa-list");
    if (list) {
      // the label's first words: 'Size' (before its 'Size it up' link), or 'Colour' of 'Colour: Grey'
      var k = document.querySelector(".pa-sizes > .pl-k"), lead = k && k.firstChild;
      var named = lead ? String(lead.textContent || "").split(":")[0].trim() : "";
      if (!list.hasAttribute("role")) list.setAttribute("role", "group");
      if (!list.hasAttribute("aria-label")) list.setAttribute("aria-label", named || "Size");
    }
    // a size not priced yet cannot be bought: its buttons are switched off while it is chosen (review S2)
    var buys = Array.prototype.slice.call(document.querySelectorAll(".ac-add, .ac-buynow, .ac-bb-add"));
    // the store's 'Notify me' sign-up for this product (Shopify /pages/notify, drawn by Alda's redirect theme -
    // scratchpad/shopify-theme/layout-theme.liquid); w=back words it for a size that is sold out rather than not yet in
    var cta = document.querySelector(".pa-cta");
    function notifyHref(name, w) {
      return "https://" + SHOP.domain + "/pages/notify?p=" + encodeURIComponent(fam.slug) + "&n=" + encodeURIComponent(name) + (w ? "&w=" + w : "");
    }
    /* A size sold out (2026-11-04, the client: a product shows out of stock, and offers to notify, only once the mother
       warehouse has none left either). Shopify counts both warehouses (the mother one fulfils online orders, ranked
       after the delivery warehouse), so availableForSale is false only then. While the chosen size is out, Buy now
       steps aside for 'Notify me when it's back'. */
    var back = null;
    function backNotify(v, out) {
      if (!cta || !shopReady()) return;
      cta.classList.toggle("is-sold-out", out);
      if (out && !back) {
        back = el("a", "pa-add pa-notify pa-notify-back kp-action");
        back.appendChild(el("span", null, "Notify me when it's back"));
        back.appendChild(el("span", "pa-notify-go", "↗"));
        back.lastChild.setAttribute("aria-hidden", "true");
        cta.appendChild(back);
      }
      if (!back) return;
      back.hidden = !out;
      if (out) back.href = notifyHref(fam.variants.length > 1 ? fam.shortName + ", " + v.label : fam.shortName, "back");
    }
    // a size sold out (window.aldaStock) is switched off the same way, and the Add to cart buttons say so
    function gate() {
      var v = fam.variants[sel], soon = unpriced(v), out = !soon && stockOut(fam.slug, v.label);
      backNotify(v, out);
      buys.forEach(function (b) {
        var off = soon || out;
        if (off && !b.disabled) { b.disabled = true; b.setAttribute("data-soon-off", ""); }
        else if (!off && b.hasAttribute("data-soon-off")) { b.disabled = false; b.removeAttribute("data-soon-off"); }
        b.classList.toggle("is-out", out);
        var words = b.classList.contains("ac-add") && b.querySelector("span:not([class])");
        if (words) {
          if (!b.__words) b.__words = words.textContent;
          words.textContent = out ? OUT : b.__words;
        }
      });
    }
    // each size button that Shopify says is sold out says so where its price was
    function markSizes() {
      pills.forEach(function (p, j) {
        var v = fam.variants[j];
        if (!v || unpriced(v) || !stockKnown(fam.slug)) return;
        var out = stockOut(fam.slug, v.label), pr = p.querySelector(".p");
        p.classList.toggle("is-out", out);
        if (!pr) return;
        if (!pr.__price) pr.__price = Array.prototype.slice.call(pr.childNodes);
        pr.replaceChildren.apply(pr, out ? [el("span", "pr is-out", OUT)] : pr.__price);
      });
    }
    function apply(i, first) {
      sel = i;
      var v = fam.variants[i], soon = unpriced(v);
      // the selling price only: the struck MRP and the % off beside it are pdp.js's (data-lab-*), from the
      // variant this event carries - sale and all
      if (price) price.textContent = soon ? soonText(v) : rupees(priceOf(v));
      if (bbVar) bbVar.textContent = v.label;
      if (bbPrice) bbPrice.textContent = soon ? soonText(v) : rupees(priceOf(v));
      gate();
      pills.forEach(function (p, j) {
        p.classList.toggle("is-active", j === i);
        if (p.classList.contains("pa-size")) p.setAttribute("aria-pressed", String(j === i));
      });
      // pdp.js shows the chosen variant's own photographs where the variants are photographed on their own (the
      // cookers' sizes differ in shape, the knife sets' colours are photographed apart - one stack per variant);
      // linked: this is the size the page opened on because its address named it
      document.dispatchEvent(new CustomEvent("alda:variant", {
        detail: { index: i, variant: v, linked: !!first && linked >= 0 }
      }));
    }
    pills.forEach(function (p, i) {
      p.addEventListener("click", function () { apply(i); writeSize(fam.variants[i].label); });
    });
    apply(sel, true);
    onStock(function () { markSizes(); gate(); });
    // Shopify's prices (live prices): the family takes them, the size buttons' and rings' figures are drawn again, and
    // the chosen size is announced again so pdp.js redraws the price, MRP, % off, dock and add button. Only when the
    // figures this page shows would change.
    function sig() { return fam.variants.map(function (v) { return v.mrp + "/" + priceOf(v); }).join(); }
    var drawn = sig();
    pdpLive = function () {
      patchLive(fam);
      writeOffers(fam);
      if (sig() === drawn) return;
      drawn = sig();
      pills.forEach(function (p, j) {
        var v = fam.variants[j], pr = p.querySelector(".p");
        if (!v || !pr) return;
        pr.__price = null;   // markSizes keeps the figure it hides behind 'Out of stock': it takes the new one below
        paint(pr, sizeCell(v));
      });
      each(".pl-ring[data-i]", function (r) {
        var v = fam.variants[+r.getAttribute("data-i")];
        if (v) paint(r.querySelector(".pl-ring-pr"), sizeCell(v));
      });
      markSizes();
      apply(sel);
    };
    /* Coming soon in every size (Evrlast - PEEK - since 2026-11-04; Ceramico too until then): 'Notify me' opens the store's own sign-up page
       for this product (Shopify /pages/notify, drawn by Alda's redirect theme - scratchpad/shopify-theme/
       layout-theme.liquid). Shopify's form and its CAPTCHA put the email in Customers, subscribed and tagged
       notify-<slug>, so the client can write to those people from Shopify Email when the product arrives. */
    if (cta && shopReady() && fam.variants.length && fam.variants.every(function (v) { return v.soon; }) && !cta.querySelector(".pa-notify")) {
      var notify = el("a", "pa-add pa-notify kp-action");
      notify.href = notifyHref(fam.shortName);
      notify.appendChild(el("span", null, "Notify me when it's in"));
      notify.appendChild(el("span", "pa-notify-go", "↗"));
      notify.lastChild.setAttribute("aria-hidden", "true");
      cta.appendChild(notify);
    }
    // the head's inline script hid the baked (hero) prices while ?size= was pending, so a 'from ₹3,290' link never
    // flashes the hero's ₹4,490 first (pdp.css html.pa-sizing); the linked size is showing now
    document.documentElement.classList.remove("pa-sizing");
    // a size the page doesn't sell: the hero is showing, so the address stops naming another
    if (asked !== null && linked < 0) writeSize(null);
    // Adding opens the drawer, and that is the confirmation. The panel button is flat, not
    // glass: glass belongs to controls floating over content, and on a flat panel it smudges.
    function currentEntry() {
      var v = fam.variants[sel];
      // a size photographed on its own (the cookers' sizes differ in shape) goes into the cart as itself; where the
      // variants are photographed on their own, one without photographs takes none of another's (lineImage)
      var own = v.gallery && v.gallery[0] && v.gallery[0].src;
      // the size as this page shows it (pdp.js keeps the dock's [data-lab-size] on the chosen size), for the drawer
      var said = document.querySelector("[data-lab-size]") || document.querySelector(".pa-size.is-active .l");
      var shown = said ? said.textContent.replace(/[ \t\r\n]+/g, " ").trim() : "";
      var entry = { slug: fam.slug, name: fam.shortName, label: v.label, mrp: v.mrp, price: priceOf(v), img: own || (perVariant(fam) ? "" : fam.img) };
      if (shown && shown !== v.label) entry.shown = shown;
      if (v.soon) entry.soon = true;   // not sold yet: every unpriced(entry) check below turns it away
      return entry;
    }
    function addCurrent(e) {
      var entry = currentEntry();
      if (unpriced(entry) || unpriced(fam.variants[sel])) return;   // not priced / not sold yet: no stream, no line
      if (stockOut(entry.slug, entry.label)) return addToCart(entry);   // sold out: no stream; the drawer says why
      // the product pages pour the photographs into the cart (cart-fly.js, from PDP C); without it - reduced
      // motion, or GSAP not loaded yet - the drawer opens, as it always did
      if (window.aldaFly && window.aldaFly.run(entry, e && e.currentTarget)) return;
      addToCart(entry);
    }
    Array.prototype.forEach.call(document.querySelectorAll(".ac-add"), function (add) {
      add.addEventListener("click", addCurrent);
    });
    // Buy now: the same line into the cart, then straight to the checkout control. Until checkout
    // is wired to a platform this is the whole express path, and an honest one. It skips the stream:
    // the stream keeps the drawer shut, and Buy now needs the drawer open to land on checkout.
    // A size already in the cart is not added again - Buy now is for one, not one more (2026-10-24, PDP review S3:
    // Add to cart then Buy now reached checkout with two): the drawer opens on the cart as it is.
    var buyNow = document.querySelector(".ac-buynow");
    if (buyNow) buyNow.addEventListener("click", function () {
      var entry = currentEntry();
      if (unpriced(entry)) return;
      var have = read().some(function (i) { return i.slug === entry.slug && i.label === entry.label; });
      if (have) open(); else addToCart(entry);   // either way the drawer is open
      setTimeout(function () {
        var co = document.querySelector(".ac-drawer .ac-checkout");
        if (co) co.focus();
      }, 350);   // once the drawer has slid in, so the focus ring lands on a settled control
    });
    // The sticky bar takes over once the buy panel has scrolled off the top - only below it,
    // never above, where the panel itself is about to come into view. Glass, like the cart
    // pill it sits opposite. Adding from it opens the drawer, which is its confirmation.
    if (bar) {
      applyGlass(bar, "pill");
      bar.querySelector(".ac-bb-add").addEventListener("click", addCurrent);
      var panel = document.querySelector(".ac-buy");
      if (panel && "IntersectionObserver" in window) {
        new IntersectionObserver(function (es) {
          var e = es[0];
          var on = !e.isIntersecting && e.boundingClientRect.bottom < 0;
          bar.classList.toggle("is-on", on);
          bar.setAttribute("aria-hidden", on ? "false" : "true");
        }).observe(panel);
      }
    }
  }

  /* ---------- the range film ----------
     An ambient loop: it plays only while on screen, and not at all for anyone who has asked for
     reduced motion - the poster stands in. Sound is opt-in through the chip; unmuting is a
     click, so the browser's autoplay policy is satisfied by the viewer's own gesture. */
  function initFilm() {
    var v = document.querySelector(".ac-film-video");
    if (!v) return;
    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!still && "IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) play(); else v.pause(); });
      }, { threshold: 0.35 }).observe(v);
    }
    var btn = document.querySelector(".ac-film-sound");
    if (btn) {
      applyGlass(btn, "chip");
      btn.addEventListener("click", function () {
        v.muted = !v.muted;
        btn.setAttribute("aria-pressed", v.muted ? "false" : "true");
        btn.setAttribute("aria-label", v.muted ? "Unmute" : "Mute");
        btn.textContent = v.muted ? "sound" : "mute";
        if (v.paused) play();
      });
    }
  }

  /* ---------- canvas focus-view links ----------
     The page loads three copies of the custom module, so the Home instance that owns the
     focus-view button clone is not the one whose clone sits in the DOM - its href assignment
     lands on a detached node and the visible "buy product" / "explore collection" keep href="#".
     Rather than edit the frozen core JS, mirror the clicked tile's destinations here. */
  /* the core builds every "explore collection" href from window.location.href, which only gave
     /collections/<slug> while the canvas sat at /. It lives at /experience-view now (the landing took /), so
     make those links root-relative wherever the core writes them - at boot and as it adds nodes. */
  /* The canvas's collection slugs are shelf slugs (cast-iron, true-glass...), and a shelf has its own listing now,
     /cook/cast-iron (2026-10-12) - /collections/<shelf> was never a page. Once the catalogue is in, every such link goes
     to the shelf's listing and keeps its slug in data-shelf; until then (or for a slug that is not a shelf) the
     root-relative /collections/<slug> stands. */
  function shelfUrl(slug) {
    if (!CATALOGUE || !slug) return null;
    for (var name in CATALOGUE.subs) {
      // in the host's form: on Shopify a shelf is /collections/<shelf> (window.aldaRoute, the 2026-11-04 theme port)
      if (CATALOGUE.subs[name].slug === slug) return routeUrl("/" + CATALOGUE.subs[name].cat + "/" + slug);
    }
    return null;
  }
  function collectionSlug(link) {
    var h = (link && link.getAttribute("href")) || "";
    var at = h.lastIndexOf("collections/");
    return link && link.getAttribute("data-shelf") || (at < 0 ? "" : h.slice(at + 12).replace(/[#?].*$/, ""));
  }
  function fixCollectionHrefs() {
    var links = document.querySelectorAll('a[href*="collections/"]');
    for (var i = 0; i < links.length; i++) {
      var h = links[i].getAttribute("href") || "";
      var slug = collectionSlug(links[i]);
      if (!slug) continue;
      var dest = shelfUrl(slug);
      if (dest) links[i].setAttribute("data-shelf", slug);
      else dest = "/collections/" + slug;
      if (h !== dest) links[i].setAttribute("href", dest);
    }
  }

  function initCanvasLinks() {
    if (!document.querySelector("[data-webshop]")) return;
    var current = null;

    function up(node, sel) {
      return node && node.closest ? node.closest(sel) : null;
    }
    function sync() {
      var group = document.querySelector(".button-group");
      if (!group || !current) return;
      var buy = group.querySelector(".button-regular");
      var exp = group.querySelector(".button-default");
      if (buy) buy.setAttribute("href", current.product);
      if (exp) exp.setAttribute("href", shelfUrl(current.collection) || "/collections/" + current.collection);
    }

    document.addEventListener("click", function (e) {
      var tile = up(e.target, "[data-webshop]");
      if (!tile || !tile.dataset.webshop) return;
      current = { product: tile.dataset.webshop, collection: tile.dataset.collectionSlug };
      lastTile = tile;
      setTimeout(sync, 0);
      setTimeout(sync, 400);
    }, true);

    // the thumbnail rail swaps the hero; its thumbs are bare clones, so match on image src
    document.addEventListener("click", function (e) {
      var rail = up(e.target, ".focusMarkeeWrapper, .focusMarkee");
      if (!rail) return;
      var im = e.target && e.target.tagName === "IMG" ? e.target : up(e.target, "img");
      if (!im) return;
      var t = tileForSrc(im.getAttribute("src"));
      if (t) lastTile = t;
    }, true);

    // a drag across the strip must not read as a click on the slide under the cursor
    var downX = 0, downY = 0, dragged = false;
    document.addEventListener("pointerdown", function (e) {
      downX = e.clientX; downY = e.clientY; dragged = false;
    }, true);
    document.addEventListener("pointermove", function (e) {
      if (!dragged && (Math.abs(e.clientX - downX) > 6 || Math.abs(e.clientY - downY) > 6)) {
        dragged = true;
      }
    }, true);

    // in the overview: a strip slide opens that product, the rest of the card opens the category
    document.addEventListener("click", function (e) {
      if (!document.body.classList.contains("ac-gridview")) return;
      if (dragged) {
        // suppress only where drags happen - a card's strip - never chrome like the cart pill
        if (up(e.target, ".collection_item")) { e.preventDefault(); e.stopPropagation(); }
        return;
      }
      var slide = up(e.target, ".ac-slide");
      if (slide && slide.getAttribute("data-webshop")) {
        e.preventDefault();
        window.location.href = slide.getAttribute("data-webshop");
        return;
      }
      var card = up(e.target, ".collection_item");
      if (!card || up(e.target, "a")) return;
      var link = card.querySelector('a[data-shelf], a[href*="/collections/"]');
      if (link) { e.preventDefault(); window.location.href = link.getAttribute("href"); }
    }, true);

    document.addEventListener("click", function (e) {
      if (!current) return;
      var buy = up(e.target, ".button-group .button-regular");
      if (buy) {
        e.preventDefault(); e.stopPropagation();
        window.location.href = current.product;
        return;
      }
      var exp = up(e.target, ".button-group .button-default");
      if (exp && exp.getAttribute("href") === "#") {
        e.preventDefault(); e.stopPropagation();
        window.location.href = shelfUrl(current.collection) || "/collections/" + current.collection;
      }
    }, true);
  }

  /* ---------- experience / home switch ----------
     Keep the core's glass button and character-hover animation, but route its alternate view
     to the landing page. Capture prevents the three inherited toggle handlers from opening
     the retired category overview. */
  function initHomeSwitch() {
    var btn = document.querySelector(".viewButton");
    if (!btn || !document.querySelector(".xp_section_collection, .xp-wrapper")) return;
    btn.setAttribute("aria-label", "Go to home");
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.assign("/");
    }, true);
  }

  /* Each category card is designed to hold a horizontally draggable strip of that collection's
     products inside `.products-collection_list` ("Drag for more"), with a 10px-radius outline the
     core fades in on scroll. Neither happens: the strip is filled by the Flip transition that
     never runs, and the outline's ScrollTrigger is disabled in canvas view - both true of the
     untouched original. Build the strip from the canvas items (cloned, so the canvas keeps its
     own) and drive it with GSAP Draggable + inertia, the same tools the core would have used. */
  function fillCategoryCards() {
    var byslug = {};
    document.querySelectorAll("[data-collection-slug][data-webshop]").forEach(function (it) {
      var s = it.dataset.collectionSlug;
      (byslug[s] = byslug[s] || []).push(it);
    });

    document.querySelectorAll(".collection_item").forEach(function (card) {
      var list = card.querySelector(".products-collection_list");
      var link = card.querySelector('a[data-shelf], a[href*="/collections/"]');
      if (!list || !link || list.children.length) return;
      var slug = collectionSlug(link);
      var items = byslug[slug] || [];
      if (!items.length) return;

      items.forEach(function (src) {
        var srcImg = src.querySelector("img");
        if (!srcImg) return;
        var slide = el("div", "ac-slide");
        slide.setAttribute("data-webshop", src.dataset.webshop || "");
        var img = el("img");
        img.src = srcImg.getAttribute("src");
        img.alt = src.dataset.name || "";
        img.loading = "lazy";
        img.width = 500; img.height = 500;
        slide.appendChild(img);
        var cap = el("span", "ac-slide-cap", src.dataset.name || "");
        slide.appendChild(cap);
        list.appendChild(slide);
      });

      card.classList.add("ac-hasstrip");
      setupStripDrag(card, list, items.length);
    });
  }

  function setupStripDrag(card, list, count) {
    var frame = card.querySelector(".collection_item-card");
    var bar = el("div", "ac-sbar");
    var thumb = el("div", "ac-sthumb");
    bar.appendChild(thumb);
    if (frame) frame.appendChild(bar);
    thumb.style.width = (100 / Math.max(count, 1)) + "%";

    function paint(x, width) {
      var p = width ? Math.min(1, Math.max(0, -x / width)) : 0;
      thumb.style.transform = "translateX(" + (p * (count - 1) * 100) + "%)";
    }

    var slideW = function () { return list.parentElement.getBoundingClientRect().width; };
    function sizeSlides() {
      var w = slideW();
      if (w) list.style.setProperty("--ac-slide-w", Math.round(w) + "px");
    }
    sizeSlides();
    window.addEventListener("resize", sizeSlides);

    var hasDraggable = typeof window.Draggable !== "undefined" && window.Draggable.create;
    if (hasDraggable) {
      var span = function () { return Math.max(0, (count - 1) * slideW()); };
      window.Draggable.create(list, {
        type: "x",
        inertia: true,
        edgeResistance: 0.9,
        bounds: { minX: -span(), maxX: 0 },
        snap: { x: function (v) { var w = slideW(); return Math.round(v / w) * w; } },
        onDrag: function () { paint(this.x, span()); },
        onThrowUpdate: function () { paint(this.x, span()); },
        onPress: function () { bar.classList.add("is-live"); },
        onRelease: function () { bar.classList.remove("is-live"); },
      });
    } else {
      // no Draggable: fall back to native horizontal scrolling
      list.parentElement.style.overflowX = "auto";
      list.parentElement.addEventListener("scroll", function () {
        paint(-this.scrollLeft, this.scrollWidth - this.clientWidth);
      });
    }
  }

  /* ---------- focus view: frosted right side carrying the product's detail ----------
     Opening a product pushes the canvas to x=62.5% and leaves it live and legible on the right,
     competing with the product on the left. A fixed frosted panel covers that region (blurring
     via backdrop-filter rather than filtering .xp-wrapper, which would blur the focused hero too
     since it is itself a canvas item) and carries the description, price and CTAs. */
  var CATALOGUE = null, focusPanel = null, focusSlug = null, lastTile = null, catalogueP = null;

  // one fetch per page, shared: the focus panel, the cart's reprice and home.js's size chooser all read it
  function loadCatalogue() {
    if (!catalogueP) catalogueP = fetchCatalogue();
    return catalogueP;
  }
  function fetchCatalogue() {
    return fetch("https://static.aldaindia.com/alda-assets/alda-products.json")
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (d) {
        CATALOGUE = { fams: {}, colls: {}, subs: {}, data: d };
        d.families.forEach(function (f) { CATALOGUE.fams[f.slug] = f; });
        d.collections.forEach(function (c) { CATALOGUE.colls[c.name] = c; });
        // the shelves (taxonomy): the eyebrow, the copy and the "more from the shelf" link read these
        (d.taxonomy || []).forEach(function (c) {
          c.subs.forEach(function (s) { CATALOGUE.subs[s.name] = { name: s.name, slug: s.slug, blurb: s.blurb, cat: c.slug }; });
        });
        // Shopify's prices, where they are in, before anything reads it (the cart's reprice above all)
        d.families.forEach(patchLive);
        return CATALOGUE;
      })
      .catch(function (e) {
        // without the catalogue the focus panel can never render and the cart keeps its saved prices - say so
        // instead of failing mute
        console.error("[alda-commerce] catalogue failed to load (focus panel disabled, cart prices not refreshed):", e);
        return null;
      });
  }

  function buildFocusPanel() {
    focusPanel = el("aside", "ac-fpanel");
    focusPanel.setAttribute("aria-live", "polite");
    focusPanel.innerHTML = "";
    var inner = el("div", "ac-fp-inner");
    /* Divs, not <p>: one of the core's reveal timelines tweens every paragraph on the page from
       {y:"2em", opacity:0}, and since this panel lives inside .page-wrapper its copy got swept in.
       The tween is then killed before it plays, freezing the text at ~2% opacity - invisible. */
    inner.appendChild(el("div", "ac-fp-eyebrow"));
    inner.appendChild(el("h2", "ac-fp-name"));
    inner.appendChild(el("div", "ac-fp-price"));
    inner.appendChild(el("div", "ac-fp-desc"));
    inner.appendChild(el("div", "ac-fp-badges"));
    inner.appendChild(el("div", "ac-fp-sizes"));
    var cta = el("div", "ac-fp-cta");
    var view = el("a", "ac-fp-btn is-primary", "view product");
    var add = el("button", "ac-fp-btn is-ghost", "add to cart");
    cta.appendChild(view);
    cta.appendChild(add);
    inner.appendChild(cta);
    inner.appendChild(el("div", "ac-fp-note"));
    // on phones the core's own "explore collection" is hidden under the sheet, so the sheet carries it
    inner.appendChild(el("a", "ac-fp-more"));
    focusPanel.appendChild(inner);
    /* Sit between the canvas and the focus UI in DOM order. All three share z-index 1000 in the
       root stacking context, so paint order decides: canvas, then this panel, then .focusWrapper -
       which means the close (x) stays on top. Raising the panel's z-index instead would bury the
       x, because it lives inside .focusWrapper, whose own z-index traps it in a stacking context. */
    var host = document.querySelector(".page-wrapper");
    var fw = document.querySelector(".focusWrapper");
    if (host && fw && fw.parentElement === host) host.insertBefore(focusPanel, fw);
    else document.body.appendChild(focusPanel);

    applyGlass(focusPanel, "panel");
    applyGlass(view, "button");
    applyGlass(add, "button");

    add.addEventListener("click", function () {
      var t = focusPanel._tile;
      if (!t) return;
      // the line shows the product's white PDP main view, not the tile's cut-out (lineImage; 2026-10-14)
      var fam = CATALOGUE && CATALOGUE.fams[t.slug], v = fam && variantOf(fam, t.variant);
      addToCart({
        slug: t.slug, name: t.shortName, label: t.variant, mrp: t.mrp, price: t.price,
        img: fam && v ? lineImage(fam, v, "") : t.img.replace(/\.webp$/, "-p-500.webp"),
      });
    });

    // The wrapper's surface is click-transparent now (so the CTAs work), which also means wheel
    // over the panel targets the panel, not the core's carousel - forward it so scrolling keeps
    // working anywhere on screen, as it did when the wrapper owned the whole surface.
    focusPanel.addEventListener("wheel", function (e) {
      var car = document.querySelector(".focusWrapper .focusCarousel");
      if (!car || !focusIsOpen()) return;
      // a short window can make the panel's own copy overflow: then the wheel scrolls the panel
      if (focusPanel.scrollHeight > focusPanel.clientHeight + 2) return;
      e.preventDefault();
      e.stopPropagation();
      car.dispatchEvent(new WheelEvent("wheel", e));
    }, { passive: false });
  }

  /* Which product is on the left. Geometry is unreliable here (several canvas items can sit in
     the left region at similar scale), so track the tile that actually opened the focus view,
     and map thumbnail-rail clicks back to their canvas tile by image src. */
  /* On phones the core moves a tile's own image into its carousel rather than cloning it, so a
     live search can find no tile holding that picture. Remember every tile's image at start-up. */
  var tileByImg = null;
  function mapTiles() {
    tileByImg = {};
    document.querySelectorAll("[data-slug]").forEach(function (t) {
      var im = t.querySelector("img");
      if (im) tileByImg[(im.getAttribute("src") || "").split("/").pop()] = t;
    });
  }
  function tileForSrc(src) {
    var file = (src || "").split("/").pop();
    if (tileByImg && tileByImg[file]) return tileByImg[file];
    var hit = null;
    document.querySelectorAll("[data-slug]").forEach(function (t) {
      var im = t.querySelector("img");
      if (!hit && im && (im.getAttribute("src") || "").split("/").pop() === file) hit = t;
    });
    return hit;
  }

  /* The hero shown on the left is a clone inside .focusWrapper, and scrolling swaps it without
     any click and without moving window.scrollY (the carousel consumes the wheel itself). So
     read the hero image and map it back to its canvas tile; lastTile is only the fallback. */
  function actuallyVisible(node) {
    // GSAP parks off-screen clones with opacity/visibility rather than removing them;
    // computed opacity is per-element (not inherited), so walk up to the wrapper
    for (var n = node; n && n !== document.body; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.visibility === "hidden" || cs.display === "none" || parseFloat(cs.opacity) < 0.3) return false;
      if (n.classList && n.classList.contains("focusWrapper")) break;
    }
    return true;
  }

  /* The core lays the focus view out two ways, and decides like this (isMobileOrTabletOrLand in
     custom/jsd): a touch device held upright stacks the collection full width and sends the canvas
     off-screen; everything else parks the canvas at 60% and leaves the right side to this panel.
     Width alone can't tell them apart, so ask the same question. In the stacked layout the panel
     is a sheet along the bottom and the carousel is lifted into the space above it. */
  function stackMode() {
    var touch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      "ontouchstart" in window;
    return touch && !window.matchMedia("(orientation: landscape)").matches;
  }
  /* The core's CSS (the styles.css of custom/csb1, csb2 and jsd) gives the focus view its side layout only on landscape screens
     768px and up, while its JS (isMobileOrTabletOrLand) lays out the side view on every screen but a touch
     one held upright - so a portrait desktop window, or a phone on its side, flew the photo to the upright
     layout's full-width spot under the panel and it had to be shrunk afterwards. html.ac-side /
     html.ac-upright carry the JS's own answer to commerce.css, which lays the carousel out for that mode,
     so the photo flies straight to where it belongs (the user, 2026-10-13). */
  function markFocusMode() {
    var upright = stackMode();
    document.documentElement.classList.toggle("ac-upright", upright);
    document.documentElement.classList.toggle("ac-side", !upright);
  }
  markFocusMode();
  window.addEventListener("resize", markFocusMode);
  // the middle of the free space between the header and the sheet, where the stacked hero belongs
  function stackCentre() {
    var head = document.querySelector(".sn-header");
    var top = head ? head.getBoundingClientRect().bottom : 0;
    var bottom = focusPanel ? focusPanel.getBoundingClientRect().top : window.innerHeight;
    return (top + bottom) / 2;
  }

  function heroImage() {
    // The carousel stacks the whole collection in one vertical column at the same x and scrolls
    // between them, so size cannot tell them apart - the hero is the one centred in the viewport
    // (in the stacked layout, centred in the space above the sheet).
    var best = null, bestDist = Infinity;
    var cy = document.body.classList.contains("ac-stack") ? stackCentre() : window.innerHeight / 2;
    document.querySelectorAll(".focusWrapper img").forEach(function (im) {
      var r = im.getBoundingClientRect();
      if (r.width < 150) return;
      // off-screen to the right only: on an upright desktop window the core centres its (oversized)
      // hero past the 60% line, so a tighter bound missed the hero itself
      if (r.left >= window.innerWidth * 0.95) return;
      if (r.bottom <= 0 || r.top >= window.innerHeight) return;
      if (!actuallyVisible(im)) return;
      var d = Math.abs((r.top + r.bottom) / 2 - cy);
      if (d < bestDist) { bestDist = d; best = im; }
    });
    return best;
  }

  function focusedTile() {
    var im = heroImage();
    if (im) {
      var t = tileForSrc(im.getAttribute("src"));
      if (t) return t;
    }
    return lastTile;
  }

  /* Pin the panel's left edge to the canvas edge - measured, not guessed, so no strip of
     unblurred canvas can show at the seam. Only accept a settled position: the canvas animates
     in from x=0, and aligning mid-flight made the panel open near-full-width and snap back. */
  function canvasLeft() {
    var canvas = document.querySelector(".xp-wrapper");
    return canvas ? Math.round(canvas.getBoundingClientRect().left) : 0;
  }
  function alignFocusPanel() {
    if (!focusPanel) return false;
    var stack = stackMode();
    // below 1024px the core draws its hero wider than the space it leaves, over the panel's buttons;
    // commerce.css lifts the panel above the hero there
    var narrow = !stack && window.innerWidth < 1024;
    // portrait side windows get commerce.css's own layout, whose photo window would clip the (x)
    var upright = !stack && window.matchMedia("(orientation: portrait), (max-width: 767.98px)").matches;
    document.body.classList.toggle("ac-stack", stack);
    document.body.classList.toggle("ac-narrow", narrow);
    if (stack || narrow || upright) {
      // On phones the core parks its close (x) inside its own navbar, which the shared header hides,
      // so a phone had no way out of the view; on narrow screens the lifted panel would cover it.
      // Move it (its listener goes with it) to the body, where commerce.css stacks it on top.
      var x = document.querySelector(".buttonCloseFocus");
      if (x && x.parentElement !== document.body) document.body.appendChild(x);
    }
    if (stack) { focusPanel.style.left = ""; return true; }
    // The focus layout parks the canvas at 60% of the viewport. Measuring mid-slide gave a
    // moving value and the panel opened too wide, so trust the target and only adopt the
    // measured edge once it agrees - which also covers the layout changing proportion.
    var target = Math.round(window.innerWidth * 0.6);
    var x = canvasLeft();
    var use = Math.abs(x - target) <= window.innerWidth * 0.06 ? x : target;
    focusPanel.style.left = use + "px";
    return true;
  }

  /* Reveal only once the canvas has stopped moving, so the panel never appears at the wrong width */
  function settleFocusPanel() {
    (function tick() {
      if (!focusIsOpen()) return;
      // position comes from the known target, so reveal as soon as there is content to show
      if (alignFocusPanel() && renderFocusPanel()) {
        document.body.classList.add("ac-focus");
        watchHero();
        return;
      }
      // no give-up while the focus view is open: the hero clone or catalogue may arrive late,
      // and a silent stop here means an unblurred right side for the rest of the view
      requestAnimationFrame(tick);
    })();
  }

  /* Scrolling the focus view swaps the hero with no click and no scroll event we can hook,
     so poll the hero image while the view is open and re-render when it changes. */
  var heroWatch = null;
  function watchHero() {
    if (heroWatch) return;
    var lastSrc = null, lastX = null;
    heroWatch = setInterval(function () {
      if (!focusIsOpen()) { clearInterval(heroWatch); heroWatch = null; return; }
      if (!document.body.classList.contains("ac-stack")) {
        // adopt the measured edge only once it has held still - the canvas overshoots as it settles
        var cx = canvasLeft();
        if (cx === lastX && Math.abs(cx - window.innerWidth * 0.6) <= window.innerWidth * 0.06) {
          focusPanel.style.left = cx + "px";
        }
        lastX = cx;
      }
      var im = heroImage();
      var src = im ? im.getAttribute("src") : null;
      if (src && src !== lastSrc) { lastSrc = src; renderFocusPanel(); }
    }, 150);
  }

  function renderFocusPanel() {
    var host = focusedTile();
    if (!host || !CATALOGUE) return false;
    var fam = CATALOGUE.fams[host.dataset.slug];
    if (!fam) return false;
    if (focusSlug === host.dataset.slug + "|" + host.dataset.variant) return true;
    focusSlug = host.dataset.slug + "|" + host.dataset.variant;

    var coll = CATALOGUE.colls[fam.collection] || {};
    var sub = CATALOGUE.subs[fam.sub] || {};
    var q = function (s) { return focusPanel.querySelector(s); };
    // the shelf, never the range: sub-brands (Vitale, Evrlast...) are internal and stay off the page
    q(".ac-fp-eyebrow").textContent = (fam.category ? fam.category + " · " : "") + (fam.sub || fam.material);
    q(".ac-fp-name").textContent = fam.shortName;
    // A tile whose picture shows every size together (data-pictured="all", scratchpad/remap_canvas.py ALL_SIZES - the
    // glass storage, 2026-10-14) is priced as the product, not as the size its picture is drawn to: the "from" price
    // leads, the sizes line prices every size, and Add to cart adds the "from" size and names it.
    var n = fam.variants.length, all = host.dataset.pictured === "all" && n > 1;
    // the tile's size, priced from the catalogue (the tile's baked data-price/-mrp only if the size went missing):
    // the selling price, and on sale the struck MRP and the % off, as on the product page
    var size = all ? fromVariant(fam) : variantOf(fam, host.dataset.variant) ||
      { label: host.dataset.variant, mrp: +host.dataset.mrp || +host.dataset.price, sale: +host.dataset.price };
    var fpPrice = q(".ac-fp-price");
    fpPrice.textContent = "";
    fpPrice.appendChild(priceNode(size, all ? fromLead(fam) : ""));
    // a cut under 1% would read '0% off': left out, as pdp.js and site_parts.off_html leave it out
    if (onSale(size) && pctOff(size) > 0) {
      fpPrice.appendChild(document.createTextNode(" "));
      fpPrice.appendChild(el("span", "pr-off", pctOff(size) + "% off"));
    }
    q(".ac-fp-desc").textContent = fam.description || sub.blurb || coll.info || "";
    var more = q(".ac-fp-more");
    if (sub.slug) {
      more.textContent = "More from " + sub.name;
      // fixCollectionHrefs reads a link's shelf from data-shelf first, so it changes with the href (2026-11-05: a stale one
      // sent the Steel Strainer's link back to the pressure cookers)
      more.setAttribute("data-shelf", sub.slug);
      more.setAttribute("href", routeUrl("/" + sub.cat + "/" + sub.slug));   // the shelf's own listing, e.g. /cook/cast-iron
      more.hidden = false;
    } else more.hidden = true;

    var badges = q(".ac-fp-badges");
    badges.textContent = "";
    (fam.badges || []).slice(0, 4).forEach(function (b) {
      badges.appendChild(el("span", "ac-fp-badge", b));
    });

    // "n sizes, from" quotes the lowest selling price, its MRP struck when that size is on sale; under a picture of every
    // size, every size with its own price instead ("3 sizes: 370 ml ₹899 · 640 ml ₹1,099 · 1040 ml ₹1,499")
    var sizes = q(".ac-fp-sizes");
    if (all) {
      sizes.textContent = n + " sizes: ";
      fam.variants.forEach(function (v, k) {
        if (k) sizes.appendChild(document.createTextNode("  ·  "));
        sizes.appendChild(document.createTextNode(v.label + " "));
        sizes.appendChild(priceNode(v));
      });
    } else if (n > 1) {
      // a set's colours are not sizes (the knife sets' grey and green, 2026-10-15): '2 options'
      sizes.textContent = host.dataset.variant + "  ·  " + n + (isSizes(fam) ? " sizes, " : " options, ");
      sizes.appendChild(priceNode(fromVariant(fam), fromLead(fam)));
    } else sizes.textContent = host.dataset.variant + "  ·  one size";
    q(".ac-fp-note").textContent = (fam.cooktop || []).length
      ? "Cooktops: " + fam.cooktop.join(" · ") : "";

    // the product page opens on this tile's size (?size=, initPDP) when there are sizes to choose between
    // (the size Add to cart adds: a tile's own, or under a picture of every size the "from" size the price leads with)
    var view = q(".ac-fp-btn.is-primary");
    view.setAttribute("href", "/products/" + fam.slug +
      (n > 1 && variantOf(fam, size.label) ? sizeQuery("", size.label) : ""));
    // Add to cart names its size when the picture shows them all ("add 370 ml to cart"; on a phone's half-width button
    // "add 370 ml", with " to cart" kept for screen readers - commerce.css .ac-fp-tocart). orbit.js keeps the button's
    // words in a .orbit-label span, so the words change there and its arrow stays. That span is a flex row with a gap,
    // so the sized words go in as one inline run (.ac-fp-words) - two flex items would open a wide gap before "to cart"
    var add = q(".ac-fp-btn.is-ghost"), addWords = all ? "add " + size.label + " to cart" : "add to cart";
    // a size not priced yet has no add to cart here (review S2); the product page still opens
    add.style.display = unpriced(size) ? "none" : "";
    var addLabel = add.querySelector(":scope > .orbit-label") || add;
    if (addLabel.textContent !== addWords) {
      addLabel.textContent = all ? "" : addWords;
      if (all) {
        var words = el("span", "ac-fp-words", "add " + size.label);
        words.appendChild(el("span", "ac-fp-tocart", " to cart"));
        addLabel.appendChild(words);
      }
    }
    // the tile's own image may be away in the core's carousel (phones), so fall back to the hero
    // and then to the family's render - reading a missing image here used to throw and stall the panel
    var im = host.querySelector("img") || heroImage();
    focusPanel._tile = {
      slug: fam.slug, shortName: fam.shortName, variant: size.label,
      price: priceOf(size), mrp: size.mrp,
      img: im ? im.getAttribute("src") : (fam.image ? "https://static.aldaindia.com/alda-assets/alda-" + fam.image + ".webp" : ""),
    };
    return true;
  }

  function focusIsOpen() {
    // query the live DOM every time - never a captured node, which can go stale if the core
    // rebuilds its UI, and never assume there is exactly one .focusWrapper
    return !!document.querySelector(".focusWrapper.pointerAll");
  }

  function initFocusPanel() {
    if (!document.querySelector(".focusWrapper") || !document.querySelector("[data-slug]")) return;
    mapTiles();
    buildFocusPanel();

    var wasOpen = false;
    function sync() {
      var open = focusIsOpen();
      if (open && !wasOpen) {
        settleFocusPanel();
        // aligning to the canvas edge resizes the panel, so remake its map once it has settled
        setTimeout(refreshAllGlass, 900);
      } else if (!open && wasOpen) {
        document.body.classList.remove("ac-focus");
        focusSlug = null;
      }
      wasOpen = open;
    }
    // observer for fast reaction where it works; 250ms poll as the guarantee - environments
    // exist where the observed node or the mutation never behaves as expected
    var wrap = document.querySelector(".focusWrapper");
    new MutationObserver(sync).observe(wrap, { attributes: true, attributeFilter: ["class"] });
    setInterval(sync, 250);
    window.addEventListener("resize", alignFocusPanel);
    // the markee rail swaps the hero without touching the wrapper's class
    document.addEventListener("click", function () {
      if (focusIsOpen()) {
        [300, 800].forEach(function (d) { setTimeout(renderFocusPanel, d); });
      }
    }, true);
    sync();
  }

  /* ---------- controls in the canvas filter-bar idiom ---------- */
  function initControls() {
    var ctls = Array.prototype.slice.call(document.querySelectorAll(".ac-ctl"));
    if (!ctls.length) return;

    ctls.forEach(function (c) {
      var btn = c.querySelector("button");
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var wasOpen = c.classList.contains("is-open");
        ctls.forEach(function (o) { o.classList.remove("is-open"); });
        c.classList.toggle("is-open", !wasOpen);
      });
    });
    document.addEventListener("click", function () {
      ctls.forEach(function (o) { o.classList.remove("is-open"); });
    });

    var sorter = document.querySelector(".ac-ctl[data-sort]");
    if (!sorter) return;
    sorter.querySelectorAll("[data-k]").forEach(function (b) {
      b.addEventListener("click", function () {
        applySort(b.dataset.k);
        sorter.querySelector("button").firstChild.nodeValue = "sort · " + b.textContent;
        sorter.classList.remove("is-open");
      });
    });
  }

  function applySort(key) {
    [".ac-grid", ".ac-rows"].forEach(function (sel) {
      var box = document.querySelector(sel);
      if (!box) return;
      var kids = Array.prototype.slice.call(box.children).filter(function (n) {
        return n.dataset && n.dataset.price;
      });
      kids.sort(function (a, b) {
        if (key === "name") return a.dataset.name.localeCompare(b.dataset.name);
        var d = (+a.dataset.price) - (+b.dataset.price);
        return key === "price-desc" ? -d : d;
      });
      kids.forEach(function (n) { box.appendChild(n); });
    });
  }

  /* The core builds its UI (.focusWrapper, .viewButton, ...) at its own pace - three module
     copies, images, fonts. A one-shot timeout is a race: on a slow load the check runs before
     the element exists, silently gives up, and the feature is dead for the whole page view.
     Poll until the dependency is really there. */
  function whenReady(check, init) {
    var tries = 0;
    (function poll() {
      if (check()) return init();
      if (++tries < 600) setTimeout(poll, 200);
    })();
  }

  /* ---------- liquid glass ----------
     Port of rdev/liquid-glass-react (MIT) to vanilla JS. The library ships React components that
     feed a baked displacement map to an SVG filter; here the map is generated per element so the
     refraction follows each surface's real size and corner radius, and the filter is handed to
     `backdrop-filter`. Only Chromium applies an SVG filter there - elsewhere this no-ops and
     commerce.css's blur, tint, rim and sheen carry the material on their own. */
  var LG_OK = (function () {
    try {
      if (!CSS.supports("backdrop-filter", "blur(1px)") &&
          !CSS.supports("-webkit-backdrop-filter", "blur(1px)")) return false;
      var brands = navigator.userAgentData && navigator.userAgentData.brands;
      // an empty brands list carries no information (a UA override produces one) - fall through
      // to the UA string rather than reading it as "not Chromium"
      if (brands && brands.length) {
        return brands.some(function (b) { return /Chromium/i.test(b.brand); });
      }
      return /Chrom(e|ium)|Edg\//.test(navigator.userAgent) && !/Firefox|FxiOS/.test(navigator.userAgent);
    } catch (e) { return false; }
  })();

  var SVGNS = "http://www.w3.org/2000/svg";
  var lgDefs = null, lgSeq = 0, lgCache = {}, lgTargets = [];

  var LG = {
    // depth: how far in from the rim the bend reaches (px). strength: how hard it pulls.
    panel:  { profile: "left", depth: 150, strength: 0.14, blur: 18, sat: 116, ab: 2.5, elastic: 0 },
    button: { profile: "rect", depth: 20,  strength: 0.36, blur: 7,  sat: 150, ab: 2,   elastic: 0.16 },
    pill:   { profile: "rect", depth: 18,  strength: 0.32, blur: 9,  sat: 150, ab: 2,   elastic: 0.12 },
    // the core's own canvas controls - no elasticity, see glassifyCore()
    chip:   { profile: "rect", depth: 16,  strength: 0.34, blur: 7,  sat: 150, ab: 2,   elastic: 0 },
    // the landing's chapter bar (home.js) - a wide square slab, a deeper rim, no elasticity
    bar:    { profile: "rect", depth: 46,  strength: 0.2,  blur: 22, sat: 150, ab: 2.5, elastic: 0 }
  };

  function smoothStep(a, b, t) {
    t = Math.max(0, Math.min(1, (t - a) / (b - a)));
    return t * t * (3 - 2 * t);
  }
  function roundedRectSDF(x, y, hw, hh, r) {
    var qx = Math.abs(x) - hw + r, qy = Math.abs(y) - hh + r;
    return Math.min(Math.max(qx, qy), 0) +
      Math.sqrt(Math.max(qx, 0) * Math.max(qx, 0) + Math.max(qy, 0) * Math.max(qy, 0)) - r;
  }

  /* Builds the displacement map. R holds the x offset and G the y offset, with 0.5 meaning "no
     displacement", so each value is stored normalised against the largest offset in the map and
     the filter's `scale` converts it back to pixels. Near the rim the sample point is pulled
     towards the centre, which magnifies whatever sits behind the edge - the lensing that reads
     as a thick piece of glass. */
  function lgMap(w, h, radius, p) {
    var s = Math.min(1, 180 / Math.max(w, h));
    var cw = Math.max(8, Math.round(w * s)), ch = Math.max(8, Math.round(h * s));
    var rr = Math.min(radius * s, Math.min(cw, ch) / 2);
    var band = Math.max(2, p.depth * s);
    var cv = document.createElement("canvas");
    cv.width = cw; cv.height = ch;
    var ctx = cv.getContext("2d");
    var img = ctx.createImageData(cw, ch);
    var raw = new Float32Array(cw * ch * 2), max = 0, x, y, i;
    for (y = 0; y < ch; y++) {
      for (x = 0; x < cw; x++) {
        i = y * cw + x;
        var ux = (x + 0.5) / cw, uy = (y + 0.5) / ch, t;
        if (p.profile === "left") {
          // the panel is flush to three viewport edges; only the divider can actually refract
          t = 1 - smoothStep(0, band, ux * cw);
        } else {
          t = 1 - smoothStep(0, band,
            -roundedRectSDF((ux - 0.5) * cw, (uy - 0.5) * ch, cw / 2, ch / 2, rr));
        }
        t = smoothStep(0, 1, t);
        var k = 1 - t * p.strength;
        var dx = ((ux - 0.5) * k + 0.5 - ux) * cw;
        var dy = p.profile === "left" ? 0 : ((uy - 0.5) * k + 0.5 - uy) * ch;
        raw[i * 2] = dx; raw[i * 2 + 1] = dy;
        if (Math.abs(dx) > max) max = Math.abs(dx);
        if (Math.abs(dy) > max) max = Math.abs(dy);
      }
    }
    if (!max) max = 1;
    for (i = 0; i < cw * ch; i++) {
      img.data[i * 4] = Math.round((raw[i * 2] / max * 0.5 + 0.5) * 255);
      img.data[i * 4 + 1] = Math.round((raw[i * 2 + 1] / max * 0.5 + 0.5) * 255);
      img.data[i * 4 + 2] = 128;
      img.data[i * 4 + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    // the map is stretched back up to the element, so the offsets scale with it
    return { url: cv.toDataURL(), scale: max * 2 / s };
  }

  /* Displaces the backdrop once per colour channel at slightly different strengths and screens the
     results back together - the fringing real glass shows at a refracting edge. */
  function lgFilter(mapUrl, scale, ab) {
    if (!lgDefs) {
      lgDefs = document.createElementNS(SVGNS, "svg");
      lgDefs.setAttribute("aria-hidden", "true");
      lgDefs.style.cssText = "position:absolute;width:0;height:0;overflow:hidden";
      document.body.appendChild(lgDefs);
    }
    var id = "ac-lg-" + (++lgSeq);
    var f = document.createElementNS(SVGNS, "filter");
    f.setAttribute("id", id);
    // clip the filter region to the element box so displaced samples can't bleed outside it
    f.setAttribute("x", "0"); f.setAttribute("y", "0");
    f.setAttribute("width", "1"); f.setAttribute("height", "1");
    f.setAttribute("color-interpolation-filters", "sRGB");

    var im = document.createElementNS(SVGNS, "feImage");
    im.setAttribute("href", mapUrl);
    im.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", mapUrl);
    im.setAttribute("preserveAspectRatio", "none");
    im.setAttribute("result", "map");
    f.appendChild(im);

    var mats = {
      R: "1 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0",
      G: "0 0 0 0 0  0 1 0 0 0  0 0 0 0 0  0 0 0 1 0",
      B: "0 0 0 0 0  0 0 0 0 0  0 0 1 0 0  0 0 0 1 0"
    };
    [["R", 1], ["G", 1 + ab * 0.05], ["B", 1 + ab * 0.1]].forEach(function (c) {
      var dm = document.createElementNS(SVGNS, "feDisplacementMap");
      dm.setAttribute("in", "SourceGraphic");
      dm.setAttribute("in2", "map");
      dm.setAttribute("scale", String(scale * c[1]));
      dm.setAttribute("xChannelSelector", "R");
      dm.setAttribute("yChannelSelector", "G");
      dm.setAttribute("result", "d" + c[0]);
      f.appendChild(dm);
      var cm = document.createElementNS(SVGNS, "feColorMatrix");
      cm.setAttribute("in", "d" + c[0]);
      cm.setAttribute("type", "matrix");
      cm.setAttribute("values", mats[c[0]]);
      cm.setAttribute("result", "c" + c[0]);
      f.appendChild(cm);
    });
    ["cR:cG:rg", "rg:cB:out"].forEach(function (spec) {
      var a = spec.split(":");
      var bl = document.createElementNS(SVGNS, "feBlend");
      bl.setAttribute("in", a[0]); bl.setAttribute("in2", a[1]);
      bl.setAttribute("mode", "screen"); bl.setAttribute("result", a[2]);
      f.appendChild(bl);
    });
    lgDefs.appendChild(f);
    return id;
  }

  function refreshGlass(entry) {
    if (!LG_OK) return;
    var node = entry.node, p = entry.p;
    var r = node.getBoundingClientRect();
    if (r.width < 4 || r.height < 4) return;
    // round the geometry so a one-pixel reflow doesn't mint a whole new filter
    var w = Math.round(r.width / 4) * 4, h = Math.round(r.height / 4) * 4;
    var radius = Math.min(
      parseFloat(getComputedStyle(node).borderTopLeftRadius) || 0, Math.min(w, h) / 2);
    var key = [p.profile, w, h, Math.round(radius)].join(":");
    if (entry.key === key) return;
    entry.key = key;
    if (!lgCache[key]) {
      var m = lgMap(w, h, radius, p);
      lgCache[key] = lgFilter(m.url, m.scale, p.ab);
    }
    var css = "blur(" + p.blur + "px) saturate(" + p.sat + "%) url(#" + lgCache[key] + ")";
    node.style.backdropFilter = css;
    node.style.webkitBackdropFilter = css;
  }

  /* The elastic part: the surface leans and stretches toward the cursor, and the specular hotspot
     tracks it. Small numbers on purpose - past a pixel or two it stops reading as a heavy material
     and starts reading as a wobble. */
  function lgTrack(node, p, e, elastic) {
    var r = node.getBoundingClientRect();
    var nx = Math.max(-1, Math.min(1, (e.clientX - r.left - r.width / 2) / (r.width / 2)));
    var ny = Math.max(-1, Math.min(1, (e.clientY - r.top - r.height / 2) / (r.height / 2)));
    var k = p.elastic;
    if (elastic) {
      // The individual translate / scale properties, not transform: they compose with a node's own
      // transform. The buy bar is centred with translate(-50%), and an inline transform replaced it,
      // so under the cursor the bar slid half its width to the right (2026-09-28).
      node.style.translate = (nx * k * 5).toFixed(2) + "px " + (ny * k * 5).toFixed(2) + "px";
      node.style.scale = (1 + Math.abs(nx) * k * 0.3 - Math.abs(ny) * k * 0.15).toFixed(4) + " " +
        (1 + Math.abs(ny) * k * 0.3 - Math.abs(nx) * k * 0.15).toFixed(4);
    }
    node.style.setProperty("--gx", ((e.clientX - r.left) / r.width * 100).toFixed(1) + "%");
    node.style.setProperty("--gy", ((e.clientY - r.top) / r.height * 100).toFixed(1) + "%");
  }

  /* `bare` skips the .ac-glass class: the core's controls get their material from commerce.css
     keyed on the core's own class names, so it survives the core rebuilding one of those nodes. */
  function applyGlass(node, preset, bare) {
    // Solid homepage controls avoid refraction compositing over scrolling media.
    if (!node || document.body.classList.contains("ac-landing")) return;
    var p = LG[preset];
    if (!bare) node.classList.add("ac-glass");
    var entry = { node: node, p: p };
    lgTargets.push(entry);
    refreshGlass(entry);
    var elastic = p.elastic && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    node.addEventListener("pointermove", function (e) { lgTrack(node, p, e, elastic); });
    node.addEventListener("pointerleave", function () {
      if (elastic) { node.style.translate = ""; node.style.scale = ""; }
      node.style.removeProperty("--gx");
      node.style.removeProperty("--gy");
    });
  }
  function refreshAllGlass() {
    lgTargets = lgTargets.filter(function (e) { return e.node.isConnected; });
    lgTargets.forEach(refreshGlass);
  }
  // The landing page's own script wants the house glass for its hero thumbnail. It loads before
  // this file, so it polls for this; registered targets are re-mapped by the resize handler below.
  window.aldaGlass = { apply: applyGlass, refresh: refreshAllGlass };
  // The landing directions' shop strip adds a family's hero size straight into the house cart
  // (home.js); the entry shape is the PDP's - slug, name, label, mrp, price (the selling price), img.
  // catalogue() -> a promise of the page's one copy of alda-products.json ({ fams, colls, subs, data } - data is the
  // file as fetched - or null when it failed), for anything that wants today's prices without a fetch of its own.
  window.aldaCart = { add: addToCart, open: open, close: close, count: count, catalogue: loadCatalogue };

  /* The canvas controls - view toggle, menu, filter, zoom, the explore buttons. These belong to the
     frozen core, which tweens `y` on several of them, so nothing here writes `transform`: two owners
     animating one transform would fight. Only the refraction filter and the specular position. */
  var CORE_CHIPS = ".viewButton .innerIcon, .viewButton .innerButton," +
    " .filterCTA .innerIcon, .filterCTA .innerButton," +
    " .filterElementWrapper .innerIcon, .filterElementWrapper .innerButton," +
    " .menu-button_icon, .menu-button_text, .button-zoom," +
    " .button-inner, .buton-inner, .button-icon-2";

  function glassifyCore() {
    document.querySelectorAll(CORE_CHIPS).forEach(function (n) {
      if (n.__acGlass) return;
      n.__acGlass = true;
      applyGlass(n, "chip", true);
    });
  }
  var lgTimer;
  window.addEventListener("resize", function () {
    clearTimeout(lgTimer);
    lgTimer = setTimeout(refreshAllGlass, 180);
  });

  window.__acDebug = function () {
    return {
      liquidGlass: LG_OK ? "on (" + lgTargets.length + " surfaces, " + lgSeq + " filters)" : "off",
      catalogue: !!CATALOGUE,
      panel: !!focusPanel,
      panelParent: focusPanel && focusPanel.parentElement ? focusPanel.parentElement.className : null,
      focusOpen: focusIsOpen(),
      revealed: document.body.classList.contains("ac-focus"),
      lastTile: lastTile ? lastTile.dataset.slug : null,
      hero: (function () { var im = heroImage(); return im ? im.getAttribute("src") : null; })()
    };
  };

  /* The seasonal strip's room (2026-10-14). On a later page of a visit, season.js (loaded below, after the header)
     would draw its strip only once it has run - and the page, already laid out under the header, would move down by the
     strip. So the room is given here, before the header is built, from what season.js last left for this tab
     (sessionStorage 'alda-season-shell': is a strip due, until when, or for which previewed day): the page is laid out
     with it from its first frame (site-nav.css, html.season-a-on), and season.js draws the strip into it or, if the
     word was stale, takes the room away. Never on the experience view, nor where the address asks for another day
     or for no season; and if season.js never comes, the room goes. */
  function seasonRoom() {
    try {
      if (document.querySelector(".xp-wrapper, #init-items-list") || /^\/experience-view(\.html)?\/?$/.test(sitePath(location.pathname))) return;
      if (/[?&]season(-at)?=/.test(location.search)) return;
      var shell = JSON.parse(window.sessionStorage.getItem("alda-season-shell") || "null");
      if (!shell || shell.v !== 1 || shell.strip !== true) return;
      if (shell.at ? window.sessionStorage.getItem("alda-season-at") !== shell.at : shell.until && Date.now() >= shell.until) return;
      document.documentElement.classList.add("season-a", "season-a-on");
      setTimeout(function () { if (!window.aldaSeason) document.documentElement.classList.remove("season-a", "season-a-on"); }, 8000);
    } catch (e) {}
  }

  function boot() {
    var scrollScript = document.createElement('script');
    scrollScript.src = 'https://static.aldaindia.com/alda-assets/smooth-scroll.js?v=2ed018be';
    document.head.appendChild(scrollScript);
    inject(); fixCollectionHrefs(); initPDP(); initFilm(); initCanvasLinks(); initControls();
    // Shopify's prices as this tab last heard them, at once (live prices); the fresh answer below draws them again
    applyLive();
    // what can be sold, for everything this page can add and everything in the cart (window.aldaStock)
    onStock(markQuickAdds);
    loadStock(pageSlugs());
    seasonRoom();
    var navScript = document.createElement("script");
    navScript.src = "https://static.aldaindia.com/alda-assets/site-nav.js?v=d1c90d7c";
    document.head.appendChild(navScript);
    // the site layer (search, forms, the content pages) runs once the header is in place
    navScript.addEventListener("load", function () {
      var siteScript = document.createElement("script");
      siteScript.src = "https://static.aldaindia.com/alda-assets/site.js?v=165f03e9";
      document.head.appendChild(siteScript);
      // The approved capsule is shared by all public pages. Design studies own their nav.
      if (!location.pathname.startsWith('https://static.aldaindia.com/output/') && !document.querySelector('script[src*="navbar-options.js"]')) {
        var capsuleStyle=document.createElement('link');
        capsuleStyle.rel='stylesheet';capsuleStyle.href='https://static.aldaindia.com/alda-assets/morphing-nav.css?v=9592fbb1';
        document.head.appendChild(capsuleStyle);
        var capsuleReady=new Promise(function(resolve){capsuleStyle.onload=resolve;capsuleStyle.onerror=resolve;});
        var motionReady=window.gsap?Promise.resolve():new Promise(function(resolve,reject){
          var motion=document.createElement('script');motion.src='https://static.aldaindia.com/gsap/3.15.0/gsap.min.js';
          motion.onload=resolve;motion.onerror=reject;document.head.appendChild(motion);
        });
        Promise.all([capsuleReady,motionReady]).then(function(){
          var capsule=document.createElement('script');capsule.src='https://static.aldaindia.com/alda-assets/morphing-nav.js?v=8df7bf06';document.head.appendChild(capsule);
        });
      }

    });
    var orbitStyle = document.createElement('link'); orbitStyle.rel = 'stylesheet'; orbitStyle.href = 'https://static.aldaindia.com/alda-assets/orbit.css?v=8a3cd13d'; document.head.appendChild(orbitStyle);
    var orbitScript = document.createElement('script'); orbitScript.src = 'https://static.aldaindia.com/alda-assets/orbit.js?v=5c359986'; document.head.appendChild(orbitScript);
    // seasonal announcements (2026-10-13): whichever festival alda-assets/content/season.json names - the strip above
    // the header, the header's festival menu and the words beside reduced prices. season.js draws nothing until its
    // stylesheet has arrived; patch-asset-versions.py stamps both addresses.
    var seasonStyle = document.createElement('link'); seasonStyle.rel = 'stylesheet'; seasonStyle.href = 'https://static.aldaindia.com/alda-assets/season.css?v=f3bbc863'; document.head.appendChild(seasonStyle);
    var seasonScript = document.createElement('script'); seasonScript.src = 'https://static.aldaindia.com/alda-assets/season.js?v=02e10973'; document.head.appendChild(seasonScript);
    if (document.querySelector("[data-webshop]")) {
      loadCatalogue().then(fixCollectionHrefs);   // the canvas's shelf links, onto the shelves' own listings
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { fixCollectionHrefs(); break; }
      }).observe(document.body, { childList: true, subtree: true });
    }
    whenReady(function () { return document.querySelector(".viewButton"); }, initHomeSwitch);
    // the core builds its controls at its own pace, and rebuilds some of them later
    whenReady(function () {
      return document.querySelector(".menu-button_text, .button-zoom, .viewButton .innerButton");
    }, function () {
      glassifyCore();
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(glassifyCore, 300);
      }).observe(document.body, { childList: true, subtree: true });
    });
    if (document.querySelector("[data-slug]")) {
      loadCatalogue().then(function () {
        whenReady(function () { return document.querySelector(".focusWrapper"); }, initFocusPanel);
      });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
})();

/* The season's invitation (season-popup.js: whichever festival season.json gives a pop-up), on every page that loads this file. */
(function(){
 if(document.querySelector('script[data-alda-season-popup]'))return;
 var script=document.createElement('script');script.src='https://static.aldaindia.com/alda-assets/season-popup.js?v=5099d879';script.dataset.aldaSeasonPopup='';document.head.appendChild(script);
})();
